<template>
    <div class="container-fluid">
        <div class="page">
            <section class="swing-anls mt-0">
                <div class="row">
                    <div class="col-lg-12 flex-column">
                        <div class="item h-100 d-flex flex-column">
                        <div class="row">
                          <div class="item col-lg-6 flex-column">영상1</div>
                          <div class="item col-lg-6 flex-column">영상2</div>
                        </div>
                        <!-- <video-player></video-player> -->
                        <div class="row swing-seq g-0">
                            <div
                            class="col"
                            @click="
                                setPlayerframe(
                                fittinginfo.swingdetailinfo.fit_address,
                                'address'
                                )
                            "
                            >
                            <span class="d-none d-sm-inline-block">address</span>
                            <img
                                class="d-sm-none d-inline-block img-fluid"
                                src="/img/swing-seq-step1.svg"
                            />
                            </div>
                            <div
                            class="col"
                            @click="
                                setPlayerframe(
                                fittinginfo.swingdetailinfo.fit_takeback,
                                'backswing'
                                )
                            "
                            >
                            <span class="d-none d-sm-inline-block">backswing</span>
                            <img
                                class="d-sm-none d-inline-block img-fluid"
                                src="/img/swing-seq-step2.svg"
                            />
                            </div>
                            <div
                            class="col"
                            @click="
                                setPlayerframe(
                                fittinginfo.swingdetailinfo.fit_top_swing,
                                'topswing'
                                )
                            "
                            >
                            <span class="d-none d-sm-inline-block">topswing</span>
                            <img
                                class="d-sm-none d-inline-block img-fluid"
                                src="/img/swing-seq-step3.svg"
                            />
                            </div>
                            <div
                            class="col"
                            @click="
                                setPlayerframe(
                                fittinginfo.swingdetailinfo.fit_down_swing,
                                'downswing'
                                )
                            "
                            >
                            <span class="d-none d-sm-inline-block">downswing</span>
                            <img
                                class="d-sm-none d-inline-block img-fluid"
                                src="/img/swing-seq-step4.svg"
                            />
                            </div>
                            <div
                            class="col"
                            @click="
                                setPlayerframe(
                                fittinginfo.swingdetailinfo.fit_impact,
                                'impact'
                                )
                            "
                            >
                            <span class="d-none d-sm-inline-block">impact</span>
                            <img
                                class="d-sm-none d-inline-block img-fluid"
                                src="/img/swing-seq-step5.svg"
                            />
                            </div>
                            <div
                            class="col"
                            @click="
                                setPlayerframe(
                                fittinginfo.swingdetailinfo.fit_follow,
                                'follow'
                                )
                            "
                            >
                            <span class="d-none d-sm-inline-block">follow-through</span>
                            <img
                                class="d-sm-none d-inline-block img-fluid"
                                src="/img/swing-seq-step6.svg"
                            />
                            </div>
                            <div
                            class="col"
                            @click="
                                setPlayerframe(
                                fittinginfo.swingdetailinfo.fit_finish,
                                'finish'
                                )
                            "
                            >
                            <span class="d-none d-sm-inline-block">finish</span>
                            <img
                                class="d-sm-none d-inline-block img-fluid"
                                src="/img/swing-seq-step7.svg"
                            />
                            </div>
                        </div>
                        <!-- golf swing sequence : 7가지 구분 동작 -->

                        <div class="swing-wt g-0 item h-100">
                            <div class="wt-info">
                                <div class="wt-value">
                                    <!-- 좌우전후 -->
                                    <div
                                    class="position-absolute top-0 start-50 translate-middle-x text-green"
                                    >
                                    L
                                    <input ref="chartDataL" value="0" />
                                    </div>
                                    <div
                                    class="position-absolute bottom-0 start-50 translate-middle-x text-green"
                                    >
                                    R
                                    <input ref="chartDataR" value="0" />
                                    </div>
                                    <div
                                    class="position-absolute top-50 end-0 translate-middle-y text-orange"
                                    >
                                    F
                                    <input ref="chartDataF" value="0" />
                                    </div>
                                    <div
                                    class="position-absolute top-50 start-0 translate-middle-y text-orange"
                                    >
                                    B
                                    <input ref="chartDataB" value="180" />
                                    </div>
                                </div>

                                <div ref="footViewChart" style="width: 100%; height: 100%;"></div>
                            </div>
                        </div>
                        <!-- 체중그래프 -->
                    </div>
                    </div>
                </div>
            </section>
            <section class="swing-anls mt-0">
                <div class="row">
                    <div class="col-lg-4 flex-column">
                        <div class="col item">
                            <div ref="sideViewChart" style="width: 100%; height: 200px"></div>
                        </div>
                    </div>
                    <div class="col-lg-4 flex-column">
                        <div class="col item">
                            <div ref="topViewChart" style="width: 100%; height: 200px"></div>
                        </div>
                    </div>
                    <div class="col-lg-4 flex-column">
                      <div class="col item">
                        이미지
                      </div>
                    </div>
                </div>
            </section>
            <!-- //골프 스윙분석 -->

            <div class="btn-bottom-wrapper">
                <b-button size="xl" variant="outline-secondary">
                    {{ $t("button.common.list") }}
                </b-button>
                <b-button size="xl" variant="secondary">
                    {{ $t("button.fitting.shot_list") }}
                </b-button>
                <b-button size="xl" variant="primary">
                    {{ $t("button.fitting.fitting_view") }}
                </b-button>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';

export default {
  name: 'MyChart',
  mounted() {
    const sideViewChart = echarts.init(this.$refs.sideViewChart); // 사이드뷰 차트
    const topViewChart = echarts.init(this.$refs.topViewChart); // 탑뷰 차트
    const footViewChart = echarts.init(this.$refs.footViewChart); // 풋뷰 차트
    
    // 사이드뷰 차트 데이터 #1
    const sideViewChartData01 = [
      {
        "x": 0,
        "y": 0
      },
      {
        "x": 1,
        "y": 0.1
      },
      {
        "x": 2,
        "y": 0.3
      },
      {
        "x": 3,
        "y": 0.5
      },
      {
        "x": 4,
        "y": 0.7
      },
      {
        "x": 6,
        "y": 0.9
      },
      {
        "x": 7,
        "y": 1.1
      },
      {
        "x": 8,
        "y": 1.3
      },
      {
        "x": 9,
        "y": 1.4
      },
      {
        "x": 10,
        "y": 1.6
      },
      {
        "x": 11,
        "y": 1.8
      },
      {
        "x": 12,
        "y": 2
      },
      {
        "x": 13,
        "y": 2.2
      },
      {
        "x": 14,
        "y": 2.3
      },
      {
        "x": 15,
        "y": 2.5
      },
      {
        "x": 16,
        "y": 2.7
      },
      {
        "x": 17,
        "y": 2.9
      },
      {
        "x": 18,
        "y": 3
      },
      {
        "x": 19,
        "y": 3.2
      },
      {
        "x": 20,
        "y": 3.4
      },
      {
        "x": 21,
        "y": 3.5
      },
      {
        "x": 22,
        "y": 3.7
      },
      {
        "x": 23,
        "y": 3.9
      },
      {
        "x": 24,
        "y": 4
      },
      {
        "x": 25,
        "y": 4.2
      },
      {
        "x": 26,
        "y": 4.3
      },
      {
        "x": 27,
        "y": 4.5
      },
      {
        "x": 28,
        "y": 4.6
      },
      {
        "x": 29,
        "y": 4.8
      },
      {
        "x": 30,
        "y": 4.9
      },
      {
        "x": 31,
        "y": 5.1
      },
      {
        "x": 32,
        "y": 5.2
      },
      {
        "x": 33,
        "y": 5.4
      },
      {
        "x": 34,
        "y": 5.5
      },
      {
        "x": 35,
        "y": 5.7
      },
      {
        "x": 36,
        "y": 5.8
      },
      {
        "x": 37,
        "y": 5.9
      },
      {
        "x": 38,
        "y": 6.1
      },
      {
        "x": 38,
        "y": 6.2
      },
      {
        "x": 39,
        "y": 6.3
      },
      {
        "x": 40,
        "y": 6.4
      },
      {
        "x": 41,
        "y": 6.6
      },
      {
        "x": 42,
        "y": 6.7
      },
      {
        "x": 43,
        "y": 6.8
      },
      {
        "x": 44,
        "y": 6.9
      },
      {
        "x": 45,
        "y": 7
      },
      {
        "x": 46,
        "y": 7.1
      },
      {
        "x": 46,
        "y": 7.2
      },
      {
        "x": 47,
        "y": 7.4
      },
      {
        "x": 48,
        "y": 7.5
      },
      {
        "x": 49,
        "y": 7.6
      },
      {
        "x": 50,
        "y": 7.7
      },
      {
        "x": 51,
        "y": 7.8
      },
      {
        "x": 52,
        "y": 7.8
      },
      {
        "x": 52,
        "y": 7.9
      },
      {
        "x": 53,
        "y": 8
      },
      {
        "x": 54,
        "y": 8.1
      },
      {
        "x": 55,
        "y": 8.2
      },
      {
        "x": 56,
        "y": 8.3
      },
      {
        "x": 57,
        "y": 8.3
      },
      {
        "x": 57,
        "y": 8.4
      },
      {
        "x": 58,
        "y": 8.5
      },
      {
        "x": 59,
        "y": 8.6
      },
      {
        "x": 60,
        "y": 8.6
      },
      {
        "x": 61,
        "y": 8.7
      },
      {
        "x": 61,
        "y": 8.8
      },
      {
        "x": 62,
        "y": 8.8
      },
      {
        "x": 63,
        "y": 8.9
      },
      {
        "x": 64,
        "y": 8.9
      },
      {
        "x": 64,
        "y": 9
      },
      {
        "x": 65,
        "y": 9
      },
      {
        "x": 66,
        "y": 9.1
      },
      {
        "x": 67,
        "y": 9.1
      },
      {
        "x": 67,
        "y": 9.1
      },
      {
        "x": 68,
        "y": 9.2
      },
      {
        "x": 69,
        "y": 9.2
      },
      {
        "x": 70,
        "y": 9.2
      },
      {
        "x": 70,
        "y": 9.3
      },
      {
        "x": 71,
        "y": 9.3
      },
      {
        "x": 72,
        "y": 9.3
      },
      {
        "x": 73,
        "y": 9.3
      },
      {
        "x": 73,
        "y": 9.3
      },
      {
        "x": 74,
        "y": 9.3
      },
      {
        "x": 75,
        "y": 9.3
      },
      {
        "x": 76,
        "y": 9.3
      },
      {
        "x": 76,
        "y": 9.3
      },
      {
        "x": 77,
        "y": 9.3
      },
      {
        "x": 78,
        "y": 9.3
      },
      {
        "x": 78,
        "y": 9.3
      },
      {
        "x": 79,
        "y": 9.3
      },
      {
        "x": 80,
        "y": 9.3
      },
      {
        "x": 80,
        "y": 9.3
      },
      {
        "x": 81,
        "y": 9.3
      },
      {
        "x": 82,
        "y": 9.2
      },
      {
        "x": 83,
        "y": 9.2
      },
      {
        "x": 83,
        "y": 9.2
      },
      {
        "x": 84,
        "y": 9.1
      },
      {
        "x": 85,
        "y": 9.1
      },
      {
        "x": 85,
        "y": 9.1
      },
      {
        "x": 86,
        "y": 9
      },
      {
        "x": 87,
        "y": 9
      },
      {
        "x": 87,
        "y": 8.9
      },
      {
        "x": 88,
        "y": 8.9
      },
      {
        "x": 89,
        "y": 8.8
      },
      {
        "x": 89,
        "y": 8.8
      },
      {
        "x": 90,
        "y": 8.7
      },
      {
        "x": 91,
        "y": 8.6
      },
      {
        "x": 91,
        "y": 8.6
      },
      {
        "x": 92,
        "y": 8.5
      },
      {
        "x": 92,
        "y": 8.4
      },
      {
        "x": 93,
        "y": 8.3
      },
      {
        "x": 94,
        "y": 8.3
      },
      {
        "x": 94,
        "y": 8.2
      },
      {
        "x": 95,
        "y": 8.1
      },
      {
        "x": 96,
        "y": 8
      },
      {
        "x": 96,
        "y": 7.9
      },
      {
        "x": 97,
        "y": 7.8
      },
      {
        "x": 98,
        "y": 7.7
      },
      {
        "x": 98,
        "y": 7.6
      },
      {
        "x": 99,
        "y": 7.5
      },
      {
        "x": 99,
        "y": 7.4
      },
      {
        "x": 100,
        "y": 7.2
      },
      {
        "x": 101,
        "y": 7.1
      },
      {
        "x": 101,
        "y": 7
      },
      {
        "x": 102,
        "y": 6.9
      },
      {
        "x": 102,
        "y": 6.7
      },
      {
        "x": 103,
        "y": 6.6
      },
      {
        "x": 104,
        "y": 6.5
      },
      {
        "x": 104,
        "y": 6.3
      },
      {
        "x": 105,
        "y": 6.2
      },
      {
        "x": 105,
        "y": 6
      },
      {
        "x": 106,
        "y": 5.9
      },
      {
        "x": 107,
        "y": 5.7
      },
      {
        "x": 107,
        "y": 5.6
      },
      {
        "x": 108,
        "y": 5.4
      },
      {
        "x": 108,
        "y": 5.3
      },
      {
        "x": 109,
        "y": 5.1
      },
      {
        "x": 110,
        "y": 4.9
      },
      {
        "x": 110,
        "y": 4.8
      },
      {
        "x": 111,
        "y": 4.6
      },
      {
        "x": 111,
        "y": 4.4
      },
      {
        "x": 112,
        "y": 4.2
      },
      {
        "x": 112,
        "y": 4
      },
      {
        "x": 113,
        "y": 3.8
      },
      {
        "x": 114,
        "y": 3.7
      },
      {
        "x": 114,
        "y": 3.5
      },
      {
        "x": 115,
        "y": 3.3
      },
      {
        "x": 115,
        "y": 3.1
      },
      {
        "x": 116,
        "y": 2.8
      },
      {
        "x": 116,
        "y": 2.6
      },
      {
        "x": 117,
        "y": 2.4
      },
      {
        "x": 117,
        "y": 2.2
      },
      {
        "x": 118,
        "y": 2
      },
      {
        "x": 119,
        "y": 1.8
      },
      {
        "x": 119,
        "y": 1.5
      },
      {
        "x": 120,
        "y": 1.3
      },
      {
        "x": 120,
        "y": 1.1
      },
      {
        "x": 121,
        "y": 0.8
      },
      {
        "x": 121,
        "y": 0.6
      },
      {
        "x": 122,
        "y": 0.4
      },
      {
        "x": 122,
        "y": 0.1
      },
      {
        "x": 123,
        "y": 0
      },
      {
        "x": 123,
        "y": 0.1
      },
      {
        "x": 123,
        "y": 0.3
      },
      {
        "x": 123,
        "y": 0.4
      },
      {
        "x": 124,
        "y": 0.6
      },
      {
        "x": 124,
        "y": 0.7
      },
      {
        "x": 124,
        "y": 0.9
      },
      {
        "x": 125,
        "y": 1
      },
      {
        "x": 125,
        "y": 1.1
      },
      {
        "x": 125,
        "y": 1.2
      },
      {
        "x": 125,
        "y": 1.4
      },
      {
        "x": 126,
        "y": 1.5
      },
      {
        "x": 126,
        "y": 1.6
      },
      {
        "x": 126,
        "y": 1.7
      },
      {
        "x": 126,
        "y": 1.7
      },
      {
        "x": 127,
        "y": 1.8
      },
      {
        "x": 127,
        "y": 1.9
      },
      {
        "x": 127,
        "y": 2
      },
      {
        "x": 128,
        "y": 2
      },
      {
        "x": 128,
        "y": 2.1
      },
      {
        "x": 128,
        "y": 2.1
      },
      {
        "x": 128,
        "y": 2.2
      },
      {
        "x": 129,
        "y": 2.2
      },
      {
        "x": 129,
        "y": 2.3
      },
      {
        "x": 129,
        "y": 2.3
      },
      {
        "x": 129,
        "y": 2.3
      },
      {
        "x": 130,
        "y": 2.3
      },
      {
        "x": 130,
        "y": 2.3
      },
      {
        "x": 130,
        "y": 2.3
      },
      {
        "x": 130,
        "y": 2.3
      },
      {
        "x": 131,
        "y": 2.3
      },
      {
        "x": 131,
        "y": 2.3
      },
      {
        "x": 131,
        "y": 2.3
      },
      {
        "x": 132,
        "y": 2.3
      },
      {
        "x": 132,
        "y": 2.2
      },
      {
        "x": 132,
        "y": 2.2
      },
      {
        "x": 132,
        "y": 2.1
      },
      {
        "x": 133,
        "y": 2.1
      },
      {
        "x": 133,
        "y": 2
      },
      {
        "x": 133,
        "y": 2
      },
      {
        "x": 133,
        "y": 1.9
      },
      {
        "x": 134,
        "y": 1.8
      },
      {
        "x": 134,
        "y": 1.7
      },
      {
        "x": 134,
        "y": 1.6
      },
      {
        "x": 135,
        "y": 1.5
      },
      {
        "x": 135,
        "y": 1.4
      },
      {
        "x": 135,
        "y": 1.3
      },
      {
        "x": 135,
        "y": 1.2
      },
      {
        "x": 136,
        "y": 1.1
      },
      {
        "x": 136,
        "y": 1
      },
      {
        "x": 136,
        "y": 0.8
      },
      {
        "x": 136,
        "y": 0.7
      },
      {
        "x": 137,
        "y": 0.6
      },
      {
        "x": 137,
        "y": 0.4
      },
      {
        "x": 137,
        "y": 0.2
      },
      {
        "x": 138,
        "y": 0.1
      },
      {
        "x": 138,
        "y": 0
      },
      {
        "x": 138,
        "y": 0
      },
      {
        "x": 138,
        "y": 0.1
      },
      {
        "x": 138,
        "y": 0.2
      },
      {
        "x": 138,
        "y": 0.3
      },
      {
        "x": 138,
        "y": 0.4
      },
      {
        "x": 139,
        "y": 0.4
      },
      {
        "x": 139,
        "y": 0.5
      },
      {
        "x": 139,
        "y": 0.6
      },
      {
        "x": 139,
        "y": 0.6
      },
      {
        "x": 139,
        "y": 0.7
      },
      {
        "x": 139,
        "y": 0.7
      },
      {
        "x": 139,
        "y": 0.7
      },
      {
        "x": 140,
        "y": 0.8
      },
      {
        "x": 140,
        "y": 0.8
      },
      {
        "x": 140,
        "y": 0.8
      },
      {
        "x": 140,
        "y": 0.8
      },
      {
        "x": 140,
        "y": 0.8
      },
      {
        "x": 140,
        "y": 0.8
      },
      {
        "x": 140,
        "y": 0.8
      },
      {
        "x": 140,
        "y": 0.8
      },
      {
        "x": 141,
        "y": 0.8
      },
      {
        "x": 141,
        "y": 0.8
      },
      {
        "x": 141,
        "y": 0.7
      },
      {
        "x": 141,
        "y": 0.7
      },
      {
        "x": 141,
        "y": 0.6
      },
      {
        "x": 141,
        "y": 0.6
      },
      {
        "x": 141,
        "y": 0.5
      },
      {
        "x": 142,
        "y": 0.5
      },
      {
        "x": 142,
        "y": 0.4
      },
      {
        "x": 142,
        "y": 0.3
      },
      {
        "x": 142,
        "y": 0.2
      },
      {
        "x": 142,
        "y": 0.2
      },
      {
        "x": 142,
        "y": 0.1
      },
      {
        "x": 142,
        "y": 0
      },
      {
        "x": 142,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 143,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 144,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 145,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      },
      {
        "x": 146,
        "y": 0
      }
    ] 

    // 사이드뷰 차트 데이터 #2
    const sideViewChartData02 =  [
      {
        "x": 0,
        "y": 0
      },
      {
        "x": 1,
        "y": 0.3
      },
      {
        "x": 2,
        "y": 0.7
      },
      {
        "x": 3,
        "y": 1.1
      },
      {
        "x": 5,
        "y": 1.5
      },
      {
        "x": 6,
        "y": 1.9
      },
      {
        "x": 7,
        "y": 2.3
      },
      {
        "x": 8,
        "y": 2.6
      },
      {
        "x": 9,
        "y": 3
      },
      {
        "x": 10,
        "y": 3.4
      },
      {
        "x": 11,
        "y": 3.7
      },
      {
        "x": 12,
        "y": 4.1
      },
      {
        "x": 13,
        "y": 4.5
      },
      {
        "x": 14,
        "y": 4.9
      },
      {
        "x": 15,
        "y": 5.2
      },
      {
        "x": 16,
        "y": 5.6
      },
      {
        "x": 18,
        "y": 5.9
      },
      {
        "x": 19,
        "y": 6.3
      },
      {
        "x": 20,
        "y": 6.6
      },
      {
        "x": 21,
        "y": 7
      },
      {
        "x": 22,
        "y": 7.4
      },
      {
        "x": 23,
        "y": 7.7
      },
      {
        "x": 24,
        "y": 8
      },
      {
        "x": 25,
        "y": 8.4
      },
      {
        "x": 26,
        "y": 8.7
      },
      {
        "x": 27,
        "y": 9.1
      },
      {
        "x": 28,
        "y": 9.4
      },
      {
        "x": 29,
        "y": 9.7
      },
      {
        "x": 30,
        "y": 10.1
      },
      {
        "x": 31,
        "y": 10.4
      },
      {
        "x": 32,
        "y": 10.7
      },
      {
        "x": 33,
        "y": 11
      },
      {
        "x": 33,
        "y": 11.4
      },
      {
        "x": 34,
        "y": 11.7
      },
      {
        "x": 35,
        "y": 12
      },
      {
        "x": 36,
        "y": 12.3
      },
      {
        "x": 37,
        "y": 12.6
      },
      {
        "x": 38,
        "y": 12.9
      },
      {
        "x": 39,
        "y": 13.2
      },
      {
        "x": 40,
        "y": 13.5
      },
      {
        "x": 41,
        "y": 13.8
      },
      {
        "x": 42,
        "y": 14.1
      },
      {
        "x": 43,
        "y": 14.4
      },
      {
        "x": 44,
        "y": 14.7
      },
      {
        "x": 44,
        "y": 15
      },
      {
        "x": 45,
        "y": 15.3
      },
      {
        "x": 46,
        "y": 15.5
      },
      {
        "x": 47,
        "y": 15.8
      },
      {
        "x": 48,
        "y": 16.1
      },
      {
        "x": 49,
        "y": 16.4
      },
      {
        "x": 50,
        "y": 16.6
      },
      {
        "x": 51,
        "y": 16.9
      },
      {
        "x": 51,
        "y": 17.2
      },
      {
        "x": 52,
        "y": 17.4
      },
      {
        "x": 53,
        "y": 17.7
      },
      {
        "x": 54,
        "y": 17.9
      },
      {
        "x": 55,
        "y": 18.2
      },
      {
        "x": 56,
        "y": 18.4
      },
      {
        "x": 56,
        "y": 18.6
      },
      {
        "x": 57,
        "y": 18.9
      },
      {
        "x": 58,
        "y": 19.1
      },
      {
        "x": 59,
        "y": 19.3
      },
      {
        "x": 60,
        "y": 19.6
      },
      {
        "x": 60,
        "y": 19.8
      },
      {
        "x": 61,
        "y": 20
      },
      {
        "x": 62,
        "y": 20.2
      },
      {
        "x": 63,
        "y": 20.4
      },
      {
        "x": 63,
        "y": 20.6
      },
      {
        "x": 64,
        "y": 20.8
      },
      {
        "x": 65,
        "y": 21
      },
      {
        "x": 66,
        "y": 21.2
      },
      {
        "x": 67,
        "y": 21.4
      },
      {
        "x": 67,
        "y": 21.6
      },
      {
        "x": 68,
        "y": 21.8
      },
      {
        "x": 69,
        "y": 22
      },
      {
        "x": 69,
        "y": 22.2
      },
      {
        "x": 70,
        "y": 22.3
      },
      {
        "x": 71,
        "y": 22.5
      },
      {
        "x": 72,
        "y": 22.7
      },
      {
        "x": 72,
        "y": 22.8
      },
      {
        "x": 73,
        "y": 23
      },
      {
        "x": 74,
        "y": 23.1
      },
      {
        "x": 75,
        "y": 23.3
      },
      {
        "x": 75,
        "y": 23.4
      },
      {
        "x": 76,
        "y": 23.6
      },
      {
        "x": 77,
        "y": 23.7
      },
      {
        "x": 77,
        "y": 23.9
      },
      {
        "x": 78,
        "y": 24
      },
      {
        "x": 79,
        "y": 24.1
      },
      {
        "x": 79,
        "y": 24.3
      },
      {
        "x": 80,
        "y": 24.4
      },
      {
        "x": 81,
        "y": 24.5
      },
      {
        "x": 81,
        "y": 24.6
      },
      {
        "x": 82,
        "y": 24.7
      },
      {
        "x": 83,
        "y": 24.8
      },
      {
        "x": 84,
        "y": 24.9
      },
      {
        "x": 84,
        "y": 25
      },
      {
        "x": 85,
        "y": 25.1
      },
      {
        "x": 85,
        "y": 25.2
      },
      {
        "x": 86,
        "y": 25.3
      },
      {
        "x": 87,
        "y": 25.4
      },
      {
        "x": 87,
        "y": 25.5
      },
      {
        "x": 88,
        "y": 25.5
      },
      {
        "x": 89,
        "y": 25.6
      },
      {
        "x": 89,
        "y": 25.7
      },
      {
        "x": 90,
        "y": 25.7
      },
      {
        "x": 91,
        "y": 25.8
      },
      {
        "x": 91,
        "y": 25.9
      },
      {
        "x": 92,
        "y": 25.9
      },
      {
        "x": 93,
        "y": 26
      },
      {
        "x": 93,
        "y": 26
      },
      {
        "x": 94,
        "y": 26
      },
      {
        "x": 94,
        "y": 26.1
      },
      {
        "x": 95,
        "y": 26.1
      },
      {
        "x": 96,
        "y": 26.1
      },
      {
        "x": 96,
        "y": 26.2
      },
      {
        "x": 97,
        "y": 26.2
      },
      {
        "x": 98,
        "y": 26.2
      },
      {
        "x": 98,
        "y": 26.2
      },
      {
        "x": 99,
        "y": 26.2
      },
      {
        "x": 99,
        "y": 26.2
      },
      {
        "x": 100,
        "y": 26.2
      },
      {
        "x": 101,
        "y": 26.2
      },
      {
        "x": 101,
        "y": 26.2
      },
      {
        "x": 102,
        "y": 26.2
      },
      {
        "x": 102,
        "y": 26.2
      },
      {
        "x": 103,
        "y": 26.2
      },
      {
        "x": 103,
        "y": 26.2
      },
      {
        "x": 104,
        "y": 26.1
      },
      {
        "x": 105,
        "y": 26.1
      },
      {
        "x": 105,
        "y": 26.1
      },
      {
        "x": 106,
        "y": 26
      },
      {
        "x": 106,
        "y": 26
      },
      {
        "x": 107,
        "y": 25.9
      },
      {
        "x": 108,
        "y": 25.9
      },
      {
        "x": 108,
        "y": 25.8
      },
      {
        "x": 109,
        "y": 25.8
      },
      {
        "x": 109,
        "y": 25.7
      },
      {
        "x": 110,
        "y": 25.6
      },
      {
        "x": 110,
        "y": 25.6
      },
      {
        "x": 111,
        "y": 25.5
      },
      {
        "x": 111,
        "y": 25.4
      },
      {
        "x": 112,
        "y": 25.3
      },
      {
        "x": 113,
        "y": 25.3
      },
      {
        "x": 113,
        "y": 25.2
      },
      {
        "x": 114,
        "y": 25.1
      },
      {
        "x": 114,
        "y": 25
      },
      {
        "x": 115,
        "y": 24.9
      },
      {
        "x": 115,
        "y": 24.8
      },
      {
        "x": 116,
        "y": 24.7
      },
      {
        "x": 116,
        "y": 24.6
      },
      {
        "x": 117,
        "y": 24.4
      },
      {
        "x": 118,
        "y": 24.3
      },
      {
        "x": 118,
        "y": 24.2
      },
      {
        "x": 119,
        "y": 24.1
      },
      {
        "x": 119,
        "y": 23.9
      },
      {
        "x": 120,
        "y": 23.8
      },
      {
        "x": 120,
        "y": 23.7
      },
      {
        "x": 121,
        "y": 23.5
      },
      {
        "x": 121,
        "y": 23.4
      },
      {
        "x": 122,
        "y": 23.2
      },
      {
        "x": 122,
        "y": 23.1
      },
      {
        "x": 123,
        "y": 22.9
      },
      {
        "x": 123,
        "y": 22.7
      },
      {
        "x": 124,
        "y": 22.6
      },
      {
        "x": 124,
        "y": 22.4
      },
      {
        "x": 125,
        "y": 22.2
      },
      {
        "x": 125,
        "y": 22
      },
      {
        "x": 126,
        "y": 21.9
      },
      {
        "x": 126,
        "y": 21.7
      },
      {
        "x": 127,
        "y": 21.5
      },
      {
        "x": 127,
        "y": 21.3
      },
      {
        "x": 128,
        "y": 21.1
      },
      {
        "x": 128,
        "y": 20.9
      },
      {
        "x": 129,
        "y": 20.7
      },
      {
        "x": 130,
        "y": 20.5
      },
      {
        "x": 130,
        "y": 20.3
      },
      {
        "x": 131,
        "y": 20
      },
      {
        "x": 131,
        "y": 19.8
      },
      {
        "x": 132,
        "y": 19.6
      },
      {
        "x": 132,
        "y": 19.4
      },
      {
        "x": 133,
        "y": 19.1
      },
      {
        "x": 133,
        "y": 18.9
      },
      {
        "x": 134,
        "y": 18.7
      },
      {
        "x": 134,
        "y": 18.4
      },
      {
        "x": 134,
        "y": 18.2
      },
      {
        "x": 135,
        "y": 17.9
      },
      {
        "x": 135,
        "y": 17.7
      },
      {
        "x": 136,
        "y": 17.4
      },
      {
        "x": 136,
        "y": 17.1
      },
      {
        "x": 137,
        "y": 16.9
      },
      {
        "x": 137,
        "y": 16.6
      },
      {
        "x": 138,
        "y": 16.3
      },
      {
        "x": 138,
        "y": 16
      },
      {
        "x": 139,
        "y": 15.8
      },
      {
        "x": 139,
        "y": 15.5
      },
      {
        "x": 140,
        "y": 15.2
      },
      {
        "x": 140,
        "y": 14.9
      },
      {
        "x": 141,
        "y": 14.6
      },
      {
        "x": 141,
        "y": 14.3
      },
      {
        "x": 142,
        "y": 14
      },
      {
        "x": 142,
        "y": 13.7
      },
      {
        "x": 143,
        "y": 13.4
      },
      {
        "x": 143,
        "y": 13.1
      },
      {
        "x": 144,
        "y": 12.8
      },
      {
        "x": 144,
        "y": 12.4
      },
      {
        "x": 145,
        "y": 12.1
      },
      {
        "x": 145,
        "y": 11.8
      },
      {
        "x": 145,
        "y": 11.5
      },
      {
        "x": 146,
        "y": 11.1
      },
      {
        "x": 146,
        "y": 10.8
      },
      {
        "x": 147,
        "y": 10.4
      },
      {
        "x": 147,
        "y": 10.1
      },
      {
        "x": 148,
        "y": 9.7
      },
      {
        "x": 148,
        "y": 9.4
      },
      {
        "x": 149,
        "y": 9
      },
      {
        "x": 149,
        "y": 8.7
      },
      {
        "x": 150,
        "y": 8.3
      },
      {
        "x": 150,
        "y": 7.9
      },
      {
        "x": 151,
        "y": 7.6
      },
      {
        "x": 151,
        "y": 7.2
      },
      {
        "x": 151,
        "y": 6.8
      },
      {
        "x": 152,
        "y": 6.4
      },
      {
        "x": 152,
        "y": 6.1
      },
      {
        "x": 153,
        "y": 5.7
      },
      {
        "x": 153,
        "y": 5.3
      },
      {
        "x": 154,
        "y": 4.9
      },
      {
        "x": 154,
        "y": 4.5
      },
      {
        "x": 155,
        "y": 4.1
      },
      {
        "x": 155,
        "y": 3.7
      },
      {
        "x": 155,
        "y": 3.3
      },
      {
        "x": 156,
        "y": 2.9
      },
      {
        "x": 156,
        "y": 2.5
      },
      {
        "x": 157,
        "y": 2
      },
      {
        "x": 157,
        "y": 1.6
      },
      {
        "x": 158,
        "y": 1.2
      },
      {
        "x": 158,
        "y": 0.8
      },
      {
        "x": 159,
        "y": 0.4
      },
      {
        "x": 159,
        "y": 0
      },
      {
        "x": 159,
        "y": 0.2
      },
      {
        "x": 159,
        "y": 0.4
      },
      {
        "x": 159,
        "y": 0.6
      },
      {
        "x": 160,
        "y": 0.8
      },
      {
        "x": 160,
        "y": 0.9
      },
      {
        "x": 160,
        "y": 1.1
      },
      {
        "x": 160,
        "y": 1.3
      },
      {
        "x": 161,
        "y": 1.5
      },
      {
        "x": 161,
        "y": 1.6
      },
      {
        "x": 161,
        "y": 1.8
      },
      {
        "x": 161,
        "y": 1.9
      },
      {
        "x": 161,
        "y": 2.1
      },
      {
        "x": 162,
        "y": 2.2
      },
      {
        "x": 162,
        "y": 2.4
      },
      {
        "x": 162,
        "y": 2.5
      },
      {
        "x": 162,
        "y": 2.6
      },
      {
        "x": 163,
        "y": 2.7
      },
      {
        "x": 163,
        "y": 2.8
      },
      {
        "x": 163,
        "y": 2.9
      },
      {
        "x": 163,
        "y": 3
      },
      {
        "x": 163,
        "y": 3.1
      },
      {
        "x": 164,
        "y": 3.2
      },
      {
        "x": 164,
        "y": 3.3
      },
      {
        "x": 164,
        "y": 3.3
      },
      {
        "x": 164,
        "y": 3.4
      },
      {
        "x": 165,
        "y": 3.5
      },
      {
        "x": 165,
        "y": 3.5
      },
      {
        "x": 165,
        "y": 3.6
      },
      {
        "x": 165,
        "y": 3.6
      },
      {
        "x": 165,
        "y": 3.6
      },
      {
        "x": 166,
        "y": 3.7
      },
      {
        "x": 166,
        "y": 3.7
      },
      {
        "x": 166,
        "y": 3.7
      },
      {
        "x": 166,
        "y": 3.7
      },
      {
        "x": 166,
        "y": 3.7
      },
      {
        "x": 167,
        "y": 3.7
      },
      {
        "x": 167,
        "y": 3.7
      },
      {
        "x": 167,
        "y": 3.7
      },
      {
        "x": 167,
        "y": 3.7
      },
      {
        "x": 168,
        "y": 3.7
      },
      {
        "x": 168,
        "y": 3.6
      },
      {
        "x": 168,
        "y": 3.6
      },
      {
        "x": 168,
        "y": 3.5
      },
      {
        "x": 168,
        "y": 3.5
      },
      {
        "x": 169,
        "y": 3.4
      },
      {
        "x": 169,
        "y": 3.4
      },
      {
        "x": 169,
        "y": 3.3
      },
      {
        "x": 169,
        "y": 3.2
      },
      {
        "x": 170,
        "y": 3.1
      },
      {
        "x": 170,
        "y": 3
      },
      {
        "x": 170,
        "y": 3
      },
      {
        "x": 170,
        "y": 2.9
      },
      {
        "x": 170,
        "y": 2.7
      },
      {
        "x": 171,
        "y": 2.6
      },
      {
        "x": 171,
        "y": 2.5
      },
      {
        "x": 171,
        "y": 2.4
      },
      {
        "x": 171,
        "y": 2.3
      },
      {
        "x": 172,
        "y": 2.1
      },
      {
        "x": 172,
        "y": 2
      },
      {
        "x": 172,
        "y": 1.8
      },
      {
        "x": 172,
        "y": 1.7
      },
      {
        "x": 172,
        "y": 1.5
      },
      {
        "x": 173,
        "y": 1.3
      },
      {
        "x": 173,
        "y": 1.2
      },
      {
        "x": 173,
        "y": 1
      },
      {
        "x": 173,
        "y": 0.8
      },
      {
        "x": 173,
        "y": 0.6
      },
      {
        "x": 174,
        "y": 0.4
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": -0.1
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 175,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 176,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      },
      {
        "x": 177,
        "y": 0
      }
    ];

    // 사이드뷰 차트 데이터 #3
    const sideViewChartData03 =  [
      {
        "x": 0,
        "y": 0
      },
      {
        "x": 1,
        "y": 0.2
      },
      {
        "x": 2,
        "y": 0.5
      },
      {
        "x": 4,
        "y": 0.8
      },
      {
        "x": 5,
        "y": 1
      },
      {
        "x": 6,
        "y": 1.3
      },
      {
        "x": 7,
        "y": 1.6
      },
      {
        "x": 8,
        "y": 1.9
      },
      {
        "x": 9,
        "y": 2.1
      },
      {
        "x": 10,
        "y": 2.4
      },
      {
        "x": 12,
        "y": 2.7
      },
      {
        "x": 13,
        "y": 2.9
      },
      {
        "x": 14,
        "y": 3.2
      },
      {
        "x": 15,
        "y": 3.4
      },
      {
        "x": 16,
        "y": 3.7
      },
      {
        "x": 17,
        "y": 4
      },
      {
        "x": 18,
        "y": 4.2
      },
      {
        "x": 19,
        "y": 4.5
      },
      {
        "x": 20,
        "y": 4.7
      },
      {
        "x": 22,
        "y": 5
      },
      {
        "x": 23,
        "y": 5.2
      },
      {
        "x": 24,
        "y": 5.5
      },
      {
        "x": 25,
        "y": 5.7
      },
      {
        "x": 26,
        "y": 6
      },
      {
        "x": 27,
        "y": 6.2
      },
      {
        "x": 28,
        "y": 6.5
      },
      {
        "x": 29,
        "y": 6.7
      },
      {
        "x": 30,
        "y": 7
      },
      {
        "x": 31,
        "y": 7.2
      },
      {
        "x": 32,
        "y": 7.4
      },
      {
        "x": 33,
        "y": 7.7
      },
      {
        "x": 34,
        "y": 7.9
      },
      {
        "x": 35,
        "y": 8.1
      },
      {
        "x": 36,
        "y": 8.4
      },
      {
        "x": 37,
        "y": 8.6
      },
      {
        "x": 38,
        "y": 8.8
      },
      {
        "x": 39,
        "y": 9
      },
      {
        "x": 40,
        "y": 9.2
      },
      {
        "x": 41,
        "y": 9.5
      },
      {
        "x": 42,
        "y": 9.7
      },
      {
        "x": 43,
        "y": 9.9
      },
      {
        "x": 44,
        "y": 10.1
      },
      {
        "x": 45,
        "y": 10.3
      },
      {
        "x": 46,
        "y": 10.5
      },
      {
        "x": 47,
        "y": 10.7
      },
      {
        "x": 48,
        "y": 10.9
      },
      {
        "x": 49,
        "y": 11.1
      },
      {
        "x": 50,
        "y": 11.3
      },
      {
        "x": 50,
        "y": 11.5
      },
      {
        "x": 51,
        "y": 11.7
      },
      {
        "x": 52,
        "y": 11.9
      },
      {
        "x": 53,
        "y": 12.1
      },
      {
        "x": 54,
        "y": 12.3
      },
      {
        "x": 55,
        "y": 12.4
      },
      {
        "x": 56,
        "y": 12.6
      },
      {
        "x": 57,
        "y": 12.8
      },
      {
        "x": 58,
        "y": 13
      },
      {
        "x": 58,
        "y": 13.1
      },
      {
        "x": 59,
        "y": 13.3
      },
      {
        "x": 60,
        "y": 13.5
      },
      {
        "x": 61,
        "y": 13.6
      },
      {
        "x": 62,
        "y": 13.8
      },
      {
        "x": 63,
        "y": 14
      },
      {
        "x": 64,
        "y": 14.1
      },
      {
        "x": 64,
        "y": 14.3
      },
      {
        "x": 65,
        "y": 14.4
      },
      {
        "x": 66,
        "y": 14.6
      },
      {
        "x": 67,
        "y": 14.7
      },
      {
        "x": 68,
        "y": 14.8
      },
      {
        "x": 69,
        "y": 15
      },
      {
        "x": 69,
        "y": 15.1
      },
      {
        "x": 70,
        "y": 15.2
      },
      {
        "x": 71,
        "y": 15.4
      },
      {
        "x": 72,
        "y": 15.5
      },
      {
        "x": 73,
        "y": 15.6
      },
      {
        "x": 73,
        "y": 15.7
      },
      {
        "x": 74,
        "y": 15.8
      },
      {
        "x": 75,
        "y": 15.9
      },
      {
        "x": 76,
        "y": 16.1
      },
      {
        "x": 76,
        "y": 16.2
      },
      {
        "x": 77,
        "y": 16.3
      },
      {
        "x": 78,
        "y": 16.4
      },
      {
        "x": 79,
        "y": 16.5
      },
      {
        "x": 79,
        "y": 16.5
      },
      {
        "x": 80,
        "y": 16.6
      },
      {
        "x": 81,
        "y": 16.7
      },
      {
        "x": 82,
        "y": 16.8
      },
      {
        "x": 82,
        "y": 16.9
      },
      {
        "x": 83,
        "y": 17
      },
      {
        "x": 84,
        "y": 17
      },
      {
        "x": 85,
        "y": 17.1
      },
      {
        "x": 85,
        "y": 17.2
      },
      {
        "x": 86,
        "y": 17.2
      },
      {
        "x": 87,
        "y": 17.3
      },
      {
        "x": 88,
        "y": 17.3
      },
      {
        "x": 88,
        "y": 17.4
      },
      {
        "x": 89,
        "y": 17.4
      },
      {
        "x": 90,
        "y": 17.5
      },
      {
        "x": 90,
        "y": 17.5
      },
      {
        "x": 91,
        "y": 17.6
      },
      {
        "x": 92,
        "y": 17.6
      },
      {
        "x": 92,
        "y": 17.6
      },
      {
        "x": 93,
        "y": 17.7
      },
      {
        "x": 94,
        "y": 17.7
      },
      {
        "x": 94,
        "y": 17.7
      },
      {
        "x": 95,
        "y": 17.7
      },
      {
        "x": 96,
        "y": 17.8
      },
      {
        "x": 97,
        "y": 17.8
      },
      {
        "x": 97,
        "y": 17.8
      },
      {
        "x": 98,
        "y": 17.8
      },
      {
        "x": 98,
        "y": 17.8
      },
      {
        "x": 99,
        "y": 17.8
      },
      {
        "x": 100,
        "y": 17.8
      },
      {
        "x": 100,
        "y": 17.8
      },
      {
        "x": 101,
        "y": 17.7
      },
      {
        "x": 102,
        "y": 17.7
      },
      {
        "x": 102,
        "y": 17.7
      },
      {
        "x": 103,
        "y": 17.7
      },
      {
        "x": 104,
        "y": 17.7
      },
      {
        "x": 104,
        "y": 17.6
      },
      {
        "x": 105,
        "y": 17.6
      },
      {
        "x": 106,
        "y": 17.6
      },
      {
        "x": 106,
        "y": 17.5
      },
      {
        "x": 107,
        "y": 17.5
      },
      {
        "x": 107,
        "y": 17.4
      },
      {
        "x": 108,
        "y": 17.4
      },
      {
        "x": 109,
        "y": 17.3
      },
      {
        "x": 109,
        "y": 17.3
      },
      {
        "x": 110,
        "y": 17.2
      },
      {
        "x": 111,
        "y": 17.1
      },
      {
        "x": 111,
        "y": 17.1
      },
      {
        "x": 112,
        "y": 17
      },
      {
        "x": 112,
        "y": 16.9
      },
      {
        "x": 113,
        "y": 16.8
      },
      {
        "x": 114,
        "y": 16.8
      },
      {
        "x": 114,
        "y": 16.7
      },
      {
        "x": 115,
        "y": 16.6
      },
      {
        "x": 115,
        "y": 16.5
      },
      {
        "x": 116,
        "y": 16.4
      },
      {
        "x": 117,
        "y": 16.3
      },
      {
        "x": 117,
        "y": 16.2
      },
      {
        "x": 118,
        "y": 16.1
      },
      {
        "x": 118,
        "y": 16
      },
      {
        "x": 119,
        "y": 15.8
      },
      {
        "x": 119,
        "y": 15.7
      },
      {
        "x": 120,
        "y": 15.6
      },
      {
        "x": 121,
        "y": 15.5
      },
      {
        "x": 121,
        "y": 15.3
      },
      {
        "x": 122,
        "y": 15.2
      },
      {
        "x": 122,
        "y": 15.1
      },
      {
        "x": 123,
        "y": 14.9
      },
      {
        "x": 124,
        "y": 14.8
      },
      {
        "x": 124,
        "y": 14.6
      },
      {
        "x": 125,
        "y": 14.5
      },
      {
        "x": 125,
        "y": 14.3
      },
      {
        "x": 126,
        "y": 14.2
      },
      {
        "x": 126,
        "y": 14
      },
      {
        "x": 127,
        "y": 13.8
      },
      {
        "x": 127,
        "y": 13.7
      },
      {
        "x": 128,
        "y": 13.5
      },
      {
        "x": 129,
        "y": 13.3
      },
      {
        "x": 129,
        "y": 13.1
      },
      {
        "x": 130,
        "y": 13
      },
      {
        "x": 130,
        "y": 12.8
      },
      {
        "x": 131,
        "y": 12.6
      },
      {
        "x": 131,
        "y": 12.4
      },
      {
        "x": 132,
        "y": 12.2
      },
      {
        "x": 132,
        "y": 12
      },
      {
        "x": 133,
        "y": 11.8
      },
      {
        "x": 133,
        "y": 11.6
      },
      {
        "x": 134,
        "y": 11.4
      },
      {
        "x": 134,
        "y": 11.1
      },
      {
        "x": 135,
        "y": 10.9
      },
      {
        "x": 136,
        "y": 10.7
      },
      {
        "x": 136,
        "y": 10.5
      },
      {
        "x": 137,
        "y": 10.2
      },
      {
        "x": 137,
        "y": 10
      },
      {
        "x": 138,
        "y": 9.8
      },
      {
        "x": 138,
        "y": 9.5
      },
      {
        "x": 139,
        "y": 9.3
      },
      {
        "x": 139,
        "y": 9
      },
      {
        "x": 140,
        "y": 8.8
      },
      {
        "x": 140,
        "y": 8.5
      },
      {
        "x": 141,
        "y": 8.3
      },
      {
        "x": 141,
        "y": 8
      },
      {
        "x": 142,
        "y": 7.7
      },
      {
        "x": 142,
        "y": 7.5
      },
      {
        "x": 143,
        "y": 7.2
      },
      {
        "x": 143,
        "y": 6.9
      },
      {
        "x": 144,
        "y": 6.7
      },
      {
        "x": 144,
        "y": 6.4
      },
      {
        "x": 145,
        "y": 6.1
      },
      {
        "x": 145,
        "y": 5.8
      },
      {
        "x": 146,
        "y": 5.5
      },
      {
        "x": 146,
        "y": 5.2
      },
      {
        "x": 147,
        "y": 4.9
      },
      {
        "x": 147,
        "y": 4.6
      },
      {
        "x": 148,
        "y": 4.3
      },
      {
        "x": 148,
        "y": 4
      },
      {
        "x": 149,
        "y": 3.7
      },
      {
        "x": 149,
        "y": 3.4
      },
      {
        "x": 150,
        "y": 3
      },
      {
        "x": 150,
        "y": 2.7
      },
      {
        "x": 151,
        "y": 2.4
      },
      {
        "x": 151,
        "y": 2.1
      },
      {
        "x": 152,
        "y": 1.7
      },
      {
        "x": 152,
        "y": 1.4
      },
      {
        "x": 153,
        "y": 1
      },
      {
        "x": 153,
        "y": 0.7
      },
      {
        "x": 154,
        "y": 0.4
      },
      {
        "x": 154,
        "y": 0
      },
      {
        "x": 154,
        "y": 0
      },
      {
        "x": 154,
        "y": 0.2
      },
      {
        "x": 155,
        "y": 0.4
      },
      {
        "x": 155,
        "y": 0.6
      },
      {
        "x": 155,
        "y": 0.8
      },
      {
        "x": 155,
        "y": 0.9
      },
      {
        "x": 156,
        "y": 1.1
      },
      {
        "x": 156,
        "y": 1.3
      },
      {
        "x": 156,
        "y": 1.5
      },
      {
        "x": 156,
        "y": 1.6
      },
      {
        "x": 157,
        "y": 1.8
      },
      {
        "x": 157,
        "y": 1.9
      },
      {
        "x": 157,
        "y": 2.1
      },
      {
        "x": 157,
        "y": 2.2
      },
      {
        "x": 158,
        "y": 2.4
      },
      {
        "x": 158,
        "y": 2.5
      },
      {
        "x": 158,
        "y": 2.6
      },
      {
        "x": 158,
        "y": 2.7
      },
      {
        "x": 159,
        "y": 2.8
      },
      {
        "x": 159,
        "y": 2.9
      },
      {
        "x": 159,
        "y": 3
      },
      {
        "x": 159,
        "y": 3.1
      },
      {
        "x": 159,
        "y": 3.2
      },
      {
        "x": 160,
        "y": 3.3
      },
      {
        "x": 160,
        "y": 3.3
      },
      {
        "x": 160,
        "y": 3.4
      },
      {
        "x": 160,
        "y": 3.5
      },
      {
        "x": 161,
        "y": 3.5
      },
      {
        "x": 161,
        "y": 3.6
      },
      {
        "x": 161,
        "y": 3.6
      },
      {
        "x": 161,
        "y": 3.6
      },
      {
        "x": 162,
        "y": 3.7
      },
      {
        "x": 162,
        "y": 3.7
      },
      {
        "x": 162,
        "y": 3.7
      },
      {
        "x": 162,
        "y": 3.7
      },
      {
        "x": 163,
        "y": 3.7
      },
      {
        "x": 163,
        "y": 3.7
      },
      {
        "x": 163,
        "y": 3.7
      },
      {
        "x": 163,
        "y": 3.7
      },
      {
        "x": 164,
        "y": 3.7
      },
      {
        "x": 164,
        "y": 3.6
      },
      {
        "x": 164,
        "y": 3.6
      },
      {
        "x": 164,
        "y": 3.6
      },
      {
        "x": 164,
        "y": 3.5
      },
      {
        "x": 165,
        "y": 3.5
      },
      {
        "x": 165,
        "y": 3.4
      },
      {
        "x": 165,
        "y": 3.3
      },
      {
        "x": 165,
        "y": 3.3
      },
      {
        "x": 166,
        "y": 3.2
      },
      {
        "x": 166,
        "y": 3.1
      },
      {
        "x": 166,
        "y": 3
      },
      {
        "x": 166,
        "y": 2.9
      },
      {
        "x": 167,
        "y": 2.8
      },
      {
        "x": 167,
        "y": 2.7
      },
      {
        "x": 167,
        "y": 2.6
      },
      {
        "x": 167,
        "y": 2.5
      },
      {
        "x": 168,
        "y": 2.4
      },
      {
        "x": 168,
        "y": 2.2
      },
      {
        "x": 168,
        "y": 2.1
      },
      {
        "x": 168,
        "y": 1.9
      },
      {
        "x": 169,
        "y": 1.8
      },
      {
        "x": 169,
        "y": 1.6
      },
      {
        "x": 169,
        "y": 1.5
      },
      {
        "x": 169,
        "y": 1.3
      },
      {
        "x": 169,
        "y": 1.1
      },
      {
        "x": 170,
        "y": 1
      },
      {
        "x": 170,
        "y": 0.8
      },
      {
        "x": 170,
        "y": 0.6
      },
      {
        "x": 170,
        "y": 0.4
      },
      {
        "x": 171,
        "y": 0.2
      },
      {
        "x": 171,
        "y": 0
      },
      {
        "x": 171,
        "y": -0.2
      },
      {
        "x": 171,
        "y": 0
      },
      {
        "x": 171,
        "y": 0
      },
      {
        "x": 171,
        "y": 0
      },
      {
        "x": 171,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 172,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 173,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      },
      {
        "x": 174,
        "y": 0
      }
    ];

    // 탑뷰 차트 데이터 #1
    const topViewChartData01 =  [
      {
        "x": 0,
        "y": 0
      },
      {
        "x": 1,
        "y": 0.2
      },
      {
        "x": 2,
        "y": 0.5
      },
      {
        "x": 3,
        "y": 0.7
      },
      {
        "x": 4,
        "y": 1
      },
      {
        "x": 6,
        "y": 1.2
      },
      {
        "x": 7,
        "y": 1.5
      },
      {
        "x": 8,
        "y": 1.7
      },
      {
        "x": 9,
        "y": 1.9
      },
      {
        "x": 10,
        "y": 2.2
      },
      {
        "x": 11,
        "y": 2.4
      },
      {
        "x": 12,
        "y": 2.6
      },
      {
        "x": 13,
        "y": 2.9
      },
      {
        "x": 14,
        "y": 3.1
      },
      {
        "x": 15,
        "y": 3.3
      },
      {
        "x": 16,
        "y": 3.5
      },
      {
        "x": 17,
        "y": 3.8
      },
      {
        "x": 18,
        "y": 4
      },
      {
        "x": 19,
        "y": 4.2
      },
      {
        "x": 20,
        "y": 4.4
      },
      {
        "x": 21,
        "y": 4.6
      },
      {
        "x": 22,
        "y": 4.8
      },
      {
        "x": 23,
        "y": 5
      },
      {
        "x": 24,
        "y": 5.2
      },
      {
        "x": 25,
        "y": 5.4
      },
      {
        "x": 26,
        "y": 5.6
      },
      {
        "x": 27,
        "y": 5.8
      },
      {
        "x": 28,
        "y": 5.9
      },
      {
        "x": 29,
        "y": 6.1
      },
      {
        "x": 30,
        "y": 6.3
      },
      {
        "x": 31,
        "y": 6.5
      },
      {
        "x": 32,
        "y": 6.7
      },
      {
        "x": 33,
        "y": 6.8
      },
      {
        "x": 34,
        "y": 7
      },
      {
        "x": 35,
        "y": 7.2
      },
      {
        "x": 36,
        "y": 7.3
      },
      {
        "x": 37,
        "y": 7.5
      },
      {
        "x": 38,
        "y": 7.6
      },
      {
        "x": 38,
        "y": 7.8
      },
      {
        "x": 39,
        "y": 7.9
      },
      {
        "x": 40,
        "y": 8.1
      },
      {
        "x": 41,
        "y": 8.2
      },
      {
        "x": 42,
        "y": 8.4
      },
      {
        "x": 43,
        "y": 8.5
      },
      {
        "x": 44,
        "y": 8.7
      },
      {
        "x": 45,
        "y": 8.8
      },
      {
        "x": 46,
        "y": 8.9
      },
      {
        "x": 46,
        "y": 9.1
      },
      {
        "x": 47,
        "y": 9.2
      },
      {
        "x": 48,
        "y": 9.3
      },
      {
        "x": 49,
        "y": 9.5
      },
      {
        "x": 50,
        "y": 9.6
      },
      {
        "x": 51,
        "y": 9.7
      },
      {
        "x": 52,
        "y": 9.8
      },
      {
        "x": 52,
        "y": 9.9
      },
      {
        "x": 53,
        "y": 10
      },
      {
        "x": 54,
        "y": 10.2
      },
      {
        "x": 55,
        "y": 10.3
      },
      {
        "x": 56,
        "y": 10.4
      },
      {
        "x": 57,
        "y": 10.5
      },
      {
        "x": 57,
        "y": 10.6
      },
      {
        "x": 58,
        "y": 10.7
      },
      {
        "x": 59,
        "y": 10.8
      },
      {
        "x": 60,
        "y": 10.9
      },
      {
        "x": 61,
        "y": 11
      },
      {
        "x": 61,
        "y": 11.1
      },
      {
        "x": 62,
        "y": 11.1
      },
      {
        "x": 63,
        "y": 11.2
      },
      {
        "x": 64,
        "y": 11.3
      },
      {
        "x": 64,
        "y": 11.4
      },
      {
        "x": 65,
        "y": 11.5
      },
      {
        "x": 66,
        "y": 11.5
      },
      {
        "x": 67,
        "y": 11.6
      },
      {
        "x": 67,
        "y": 11.7
      },
      {
        "x": 68,
        "y": 11.8
      },
      {
        "x": 69,
        "y": 11.8
      },
      {
        "x": 70,
        "y": 11.9
      },
      {
        "x": 70,
        "y": 12
      },
      {
        "x": 71,
        "y": 12
      },
      {
        "x": 72,
        "y": 12.1
      },
      {
        "x": 73,
        "y": 12.2
      },
      {
        "x": 73,
        "y": 12.2
      },
      {
        "x": 74,
        "y": 12.3
      },
      {
        "x": 75,
        "y": 12.3
      },
      {
        "x": 76,
        "y": 12.4
      },
      {
        "x": 76,
        "y": 12.4
      },
      {
        "x": 77,
        "y": 12.5
      },
      {
        "x": 78,
        "y": 12.5
      },
      {
        "x": 78,
        "y": 12.6
      },
      {
        "x": 79,
        "y": 12.6
      },
      {
        "x": 80,
        "y": 12.6
      },
      {
        "x": 80,
        "y": 12.7
      },
      {
        "x": 81,
        "y": 12.7
      },
      {
        "x": 82,
        "y": 12.8
      },
      {
        "x": 83,
        "y": 12.8
      },
      {
        "x": 83,
        "y": 12.8
      },
      {
        "x": 84,
        "y": 12.8
      },
      {
        "x": 85,
        "y": 12.9
      },
      {
        "x": 85,
        "y": 12.9
      },
      {
        "x": 86,
        "y": 12.9
      },
      {
        "x": 87,
        "y": 12.9
      },
      {
        "x": 87,
        "y": 13
      },
      {
        "x": 88,
        "y": 13
      },
      {
        "x": 89,
        "y": 13
      },
      {
        "x": 89,
        "y": 13
      },
      {
        "x": 90,
        "y": 13
      },
      {
        "x": 91,
        "y": 13.1
      },
      {
        "x": 91,
        "y": 13.1
      },
      {
        "x": 92,
        "y": 13.1
      },
      {
        "x": 92,
        "y": 13.1
      },
      {
        "x": 93,
        "y": 13.1
      },
      {
        "x": 94,
        "y": 13.1
      },
      {
        "x": 94,
        "y": 13.1
      },
      {
        "x": 95,
        "y": 13.1
      },
      {
        "x": 96,
        "y": 13.1
      },
      {
        "x": 96,
        "y": 13.1
      },
      {
        "x": 97,
        "y": 13.1
      },
      {
        "x": 98,
        "y": 13.1
      },
      {
        "x": 98,
        "y": 13.1
      },
      {
        "x": 99,
        "y": 13.1
      },
      {
        "x": 99,
        "y": 13.1
      },
      {
        "x": 100,
        "y": 13.1
      },
      {
        "x": 101,
        "y": 13.1
      },
      {
        "x": 101,
        "y": 13
      },
      {
        "x": 102,
        "y": 13
      },
      {
        "x": 102,
        "y": 13
      },
      {
        "x": 103,
        "y": 13
      },
      {
        "x": 104,
        "y": 13
      },
      {
        "x": 104,
        "y": 13
      },
      {
        "x": 105,
        "y": 12.9
      },
      {
        "x": 105,
        "y": 12.9
      },
      {
        "x": 106,
        "y": 12.9
      },
      {
        "x": 107,
        "y": 12.9
      },
      {
        "x": 107,
        "y": 12.8
      },
      {
        "x": 108,
        "y": 12.8
      },
      {
        "x": 108,
        "y": 12.8
      },
      {
        "x": 109,
        "y": 12.8
      },
      {
        "x": 110,
        "y": 12.7
      },
      {
        "x": 110,
        "y": 12.7
      },
      {
        "x": 111,
        "y": 12.7
      },
      {
        "x": 111,
        "y": 12.6
      },
      {
        "x": 112,
        "y": 12.6
      },
      {
        "x": 112,
        "y": 12.6
      },
      {
        "x": 113,
        "y": 12.5
      },
      {
        "x": 114,
        "y": 12.5
      },
      {
        "x": 114,
        "y": 12.4
      },
      {
        "x": 115,
        "y": 12.4
      },
      {
        "x": 115,
        "y": 12.3
      },
      {
        "x": 116,
        "y": 12.3
      },
      {
        "x": 116,
        "y": 12.3
      },
      {
        "x": 117,
        "y": 12.2
      },
      {
        "x": 117,
        "y": 12.2
      },
      {
        "x": 118,
        "y": 12.1
      },
      {
        "x": 119,
        "y": 12.1
      },
      {
        "x": 119,
        "y": 12
      },
      {
        "x": 120,
        "y": 11.9
      },
      {
        "x": 120,
        "y": 11.9
      },
      {
        "x": 121,
        "y": 11.8
      },
      {
        "x": 121,
        "y": 11.8
      },
      {
        "x": 122,
        "y": 11.7
      },
      {
        "x": 122,
        "y": 11.7
      },
      {
        "x": 123,
        "y": 11.6
      },
      {
        "x": 123,
        "y": 11.6
      },
      {
        "x": 123,
        "y": 11.6
      },
      {
        "x": 123,
        "y": 11.5
      },
      {
        "x": 124,
        "y": 11.5
      },
      {
        "x": 124,
        "y": 11.5
      },
      {
        "x": 124,
        "y": 11.4
      },
      {
        "x": 125,
        "y": 11.4
      },
      {
        "x": 125,
        "y": 11.4
      },
      {
        "x": 125,
        "y": 11.4
      },
      {
        "x": 125,
        "y": 11.3
      },
      {
        "x": 126,
        "y": 11.3
      },
      {
        "x": 126,
        "y": 11.3
      },
      {
        "x": 126,
        "y": 11.2
      },
      {
        "x": 126,
        "y": 11.2
      },
      {
        "x": 127,
        "y": 11.2
      },
      {
        "x": 127,
        "y": 11.1
      },
      {
        "x": 127,
        "y": 11.1
      },
      {
        "x": 128,
        "y": 11.1
      },
      {
        "x": 128,
        "y": 11
      },
      {
        "x": 128,
        "y": 11
      },
      {
        "x": 128,
        "y": 11
      },
      {
        "x": 129,
        "y": 11
      },
      {
        "x": 129,
        "y": 10.9
      },
      {
        "x": 129,
        "y": 10.9
      },
      {
        "x": 129,
        "y": 10.9
      },
      {
        "x": 130,
        "y": 10.8
      },
      {
        "x": 130,
        "y": 10.8
      },
      {
        "x": 130,
        "y": 10.8
      },
      {
        "x": 130,
        "y": 10.7
      },
      {
        "x": 131,
        "y": 10.7
      },
      {
        "x": 131,
        "y": 10.7
      },
      {
        "x": 131,
        "y": 10.7
      },
      {
        "x": 132,
        "y": 10.6
      },
      {
        "x": 132,
        "y": 10.6
      },
      {
        "x": 132,
        "y": 10.6
      },
      {
        "x": 132,
        "y": 10.5
      },
      {
        "x": 133,
        "y": 10.5
      },
      {
        "x": 133,
        "y": 10.5
      },
      {
        "x": 133,
        "y": 10.4
      },
      {
        "x": 133,
        "y": 10.4
      },
      {
        "x": 134,
        "y": 10.4
      },
      {
        "x": 134,
        "y": 10.3
      },
      {
        "x": 134,
        "y": 10.3
      },
      {
        "x": 135,
        "y": 10.3
      },
      {
        "x": 135,
        "y": 10.3
      },
      {
        "x": 135,
        "y": 10.2
      },
      {
        "x": 135,
        "y": 10.2
      },
      {
        "x": 136,
        "y": 10.2
      },
      {
        "x": 136,
        "y": 10.1
      },
      {
        "x": 136,
        "y": 10.1
      },
      {
        "x": 136,
        "y": 10.1
      },
      {
        "x": 137,
        "y": 10
      },
      {
        "x": 137,
        "y": 10
      },
      {
        "x": 137,
        "y": 10
      },
      {
        "x": 138,
        "y": 9.9
      },
      {
        "x": 138,
        "y": 9.9
      },
      {
        "x": 138,
        "y": 9.9
      },
      {
        "x": 138,
        "y": 9.9
      },
      {
        "x": 138,
        "y": 9.9
      },
      {
        "x": 138,
        "y": 9.9
      },
      {
        "x": 138,
        "y": 9.8
      },
      {
        "x": 139,
        "y": 9.8
      },
      {
        "x": 139,
        "y": 9.8
      },
      {
        "x": 139,
        "y": 9.8
      },
      {
        "x": 139,
        "y": 9.8
      },
      {
        "x": 139,
        "y": 9.8
      },
      {
        "x": 139,
        "y": 9.8
      },
      {
        "x": 139,
        "y": 9.7
      },
      {
        "x": 140,
        "y": 9.7
      },
      {
        "x": 140,
        "y": 9.7
      },
      {
        "x": 140,
        "y": 9.7
      },
      {
        "x": 140,
        "y": 9.7
      },
      {
        "x": 140,
        "y": 9.7
      },
      {
        "x": 140,
        "y": 9.6
      },
      {
        "x": 140,
        "y": 9.6
      },
      {
        "x": 140,
        "y": 9.6
      },
      {
        "x": 141,
        "y": 9.6
      },
      {
        "x": 141,
        "y": 9.6
      },
      {
        "x": 141,
        "y": 9.6
      },
      {
        "x": 141,
        "y": 9.6
      },
      {
        "x": 141,
        "y": 9.5
      },
      {
        "x": 141,
        "y": 9.5
      },
      {
        "x": 141,
        "y": 9.5
      },
      {
        "x": 142,
        "y": 9.5
      },
      {
        "x": 142,
        "y": 9.5
      },
      {
        "x": 142,
        "y": 9.5
      },
      {
        "x": 142,
        "y": 9.4
      },
      {
        "x": 142,
        "y": 9.4
      },
      {
        "x": 142,
        "y": 9.4
      },
      {
        "x": 142,
        "y": 9.4
      },
      {
        "x": 142,
        "y": 9.4
      },
      {
        "x": 143,
        "y": 9.4
      },
      {
        "x": 143,
        "y": 9.4
      },
      {
        "x": 143,
        "y": 9.4
      },
      {
        "x": 143,
        "y": 9.3
      },
      {
        "x": 143,
        "y": 9.3
      },
      {
        "x": 143,
        "y": 9.3
      },
      {
        "x": 143,
        "y": 9.3
      },
      {
        "x": 143,
        "y": 9.3
      },
      {
        "x": 143,
        "y": 9.3
      },
      {
        "x": 143,
        "y": 9.3
      },
      {
        "x": 143,
        "y": 9.3
      },
      {
        "x": 143,
        "y": 9.3
      },
      {
        "x": 143,
        "y": 9.3
      },
      {
        "x": 144,
        "y": 9.3
      },
      {
        "x": 144,
        "y": 9.3
      },
      {
        "x": 144,
        "y": 9.3
      },
      {
        "x": 144,
        "y": 9.2
      },
      {
        "x": 144,
        "y": 9.2
      },
      {
        "x": 144,
        "y": 9.2
      },
      {
        "x": 144,
        "y": 9.2
      },
      {
        "x": 144,
        "y": 9.2
      },
      {
        "x": 144,
        "y": 9.2
      },
      {
        "x": 144,
        "y": 9.2
      },
      {
        "x": 144,
        "y": 9.2
      },
      {
        "x": 144,
        "y": 9.2
      },
    ];

    // 탑뷰 차트 데이터 #2
    const topViewChartData02 =  [
      {
        "x": 0,
        "y": 0
      },
      {
        "x": 1,
        "y": 0.2
      },
      {
        "x": 2,
        "y": 0.5
      },
      {
        "x": 3,
        "y": 0.8
      },
      {
        "x": 5,
        "y": 1.1
      },
      {
        "x": 6,
        "y": 1.3
      },
      {
        "x": 7,
        "y": 1.6
      },
      {
        "x": 8,
        "y": 1.9
      },
      {
        "x": 9,
        "y": 2.1
      },
      {
        "x": 10,
        "y": 2.4
      },
      {
        "x": 11,
        "y": 2.7
      },
      {
        "x": 12,
        "y": 2.9
      },
      {
        "x": 13,
        "y": 3.2
      },
      {
        "x": 14,
        "y": 3.4
      },
      {
        "x": 15,
        "y": 3.7
      },
      {
        "x": 16,
        "y": 3.9
      },
      {
        "x": 18,
        "y": 4.1
      },
      {
        "x": 19,
        "y": 4.4
      },
      {
        "x": 20,
        "y": 4.6
      },
      {
        "x": 21,
        "y": 4.8
      },
      {
        "x": 22,
        "y": 5.1
      },
      {
        "x": 23,
        "y": 5.3
      },
      {
        "x": 24,
        "y": 5.5
      },
      {
        "x": 25,
        "y": 5.7
      },
      {
        "x": 26,
        "y": 6
      },
      {
        "x": 27,
        "y": 6.2
      },
      {
        "x": 28,
        "y": 6.4
      },
      {
        "x": 29,
        "y": 6.6
      },
      {
        "x": 30,
        "y": 6.8
      },
      {
        "x": 31,
        "y": 7
      },
      {
        "x": 32,
        "y": 7.2
      },
      {
        "x": 33,
        "y": 7.4
      },
      {
        "x": 33,
        "y": 7.6
      },
      {
        "x": 34,
        "y": 7.8
      },
      {
        "x": 35,
        "y": 7.9
      },
      {
        "x": 36,
        "y": 8.1
      },
      {
        "x": 37,
        "y": 8.3
      },
      {
        "x": 38,
        "y": 8.5
      },
      {
        "x": 39,
        "y": 8.7
      },
      {
        "x": 40,
        "y": 8.8
      },
      {
        "x": 41,
        "y": 9
      },
      {
        "x": 42,
        "y": 9.2
      },
      {
        "x": 43,
        "y": 9.3
      },
      {
        "x": 44,
        "y": 9.5
      },
      {
        "x": 44,
        "y": 9.7
      },
      {
        "x": 45,
        "y": 9.8
      },
      {
        "x": 46,
        "y": 10
      },
      {
        "x": 47,
        "y": 10.1
      },
      {
        "x": 48,
        "y": 10.3
      },
      {
        "x": 49,
        "y": 10.4
      },
      {
        "x": 50,
        "y": 10.6
      },
      {
        "x": 51,
        "y": 10.7
      },
      {
        "x": 51,
        "y": 10.9
      },
      {
        "x": 52,
        "y": 11
      },
      {
        "x": 53,
        "y": 11.1
      },
      {
        "x": 54,
        "y": 11.3
      },
      {
        "x": 55,
        "y": 11.4
      },
      {
        "x": 56,
        "y": 11.5
      },
      {
        "x": 56,
        "y": 11.6
      },
      {
        "x": 57,
        "y": 11.8
      },
      {
        "x": 58,
        "y": 11.9
      },
      {
        "x": 59,
        "y": 12
      },
      {
        "x": 60,
        "y": 12.1
      },
      {
        "x": 60,
        "y": 12.2
      },
      {
        "x": 61,
        "y": 12.3
      },
      {
        "x": 62,
        "y": 12.4
      },
      {
        "x": 63,
        "y": 12.6
      },
      {
        "x": 63,
        "y": 12.7
      },
      {
        "x": 64,
        "y": 12.8
      },
      {
        "x": 65,
        "y": 12.9
      },
      {
        "x": 66,
        "y": 13
      },
      {
        "x": 67,
        "y": 13.1
      },
      {
        "x": 67,
        "y": 13.1
      },
      {
        "x": 68,
        "y": 13.2
      },
      {
        "x": 69,
        "y": 13.3
      },
      {
        "x": 69,
        "y": 13.4
      },
      {
        "x": 70,
        "y": 13.5
      },
      {
        "x": 71,
        "y": 13.6
      },
      {
        "x": 72,
        "y": 13.7
      },
      {
        "x": 72,
        "y": 13.7
      },
      {
        "x": 73,
        "y": 13.8
      },
      {
        "x": 74,
        "y": 13.9
      },
      {
        "x": 75,
        "y": 14
      },
      {
        "x": 75,
        "y": 14
      },
      {
        "x": 76,
        "y": 14.1
      },
      {
        "x": 77,
        "y": 14.2
      },
      {
        "x": 77,
        "y": 14.2
      },
      {
        "x": 78,
        "y": 14.3
      },
      {
        "x": 79,
        "y": 14.4
      },
      {
        "x": 79,
        "y": 14.4
      },
      {
        "x": 80,
        "y": 14.5
      },
      {
        "x": 81,
        "y": 14.5
      },
      {
        "x": 81,
        "y": 14.6
      },
      {
        "x": 82,
        "y": 14.6
      },
      {
        "x": 83,
        "y": 14.7
      },
      {
        "x": 84,
        "y": 14.8
      },
      {
        "x": 84,
        "y": 14.8
      },
      {
        "x": 85,
        "y": 14.8
      },
      {
        "x": 85,
        "y": 14.9
      },
      {
        "x": 86,
        "y": 14.9
      },
      {
        "x": 87,
        "y": 15
      },
      {
        "x": 87,
        "y": 15
      },
      {
        "x": 88,
        "y": 15.1
      },
      {
        "x": 89,
        "y": 15.1
      },
      {
        "x": 89,
        "y": 15.1
      },
      {
        "x": 90,
        "y": 15.2
      },
      {
        "x": 91,
        "y": 15.2
      },
      {
        "x": 91,
        "y": 15.2
      },
      {
        "x": 92,
        "y": 15.2
      },
      {
        "x": 93,
        "y": 15.3
      },
      {
        "x": 93,
        "y": 15.3
      },
      {
        "x": 94,
        "y": 15.3
      },
      {
        "x": 94,
        "y": 15.3
      },
      {
        "x": 95,
        "y": 15.4
      },
      {
        "x": 96,
        "y": 15.4
      },
      {
        "x": 96,
        "y": 15.4
      },
      {
        "x": 97,
        "y": 15.4
      },
      {
        "x": 98,
        "y": 15.4
      },
      {
        "x": 98,
        "y": 15.5
      },
      {
        "x": 99,
        "y": 15.5
      },
      {
        "x": 99,
        "y": 15.5
      },
      {
        "x": 100,
        "y": 15.5
      },
      {
        "x": 101,
        "y": 15.5
      },
      {
        "x": 101,
        "y": 15.5
      },
      {
        "x": 102,
        "y": 15.5
      },
      {
        "x": 102,
        "y": 15.5
      },
      {
        "x": 103,
        "y": 15.5
      },
      {
        "x": 103,
        "y": 15.5
      },
      {
        "x": 104,
        "y": 15.5
      },
      {
        "x": 105,
        "y": 15.5
      },
      {
        "x": 105,
        "y": 15.5
      },
      {
        "x": 106,
        "y": 15.5
      },
      {
        "x": 106,
        "y": 15.5
      },
      {
        "x": 107,
        "y": 15.5
      },
      {
        "x": 108,
        "y": 15.5
      },
      {
        "x": 108,
        "y": 15.5
      },
      {
        "x": 109,
        "y": 15.5
      },
      {
        "x": 109,
        "y": 15.5
      },
      {
        "x": 110,
        "y": 15.4
      },
      {
        "x": 110,
        "y": 15.4
      },
      {
        "x": 111,
        "y": 15.4
      },
      {
        "x": 111,
        "y": 15.4
      },
      {
        "x": 112,
        "y": 15.4
      },
      {
        "x": 113,
        "y": 15.4
      },
      {
        "x": 113,
        "y": 15.3
      },
      {
        "x": 114,
        "y": 15.3
      },
      {
        "x": 114,
        "y": 15.3
      },
      {
        "x": 115,
        "y": 15.3
      },
      {
        "x": 115,
        "y": 15.3
      },
      {
        "x": 116,
        "y": 15.2
      },
      {
        "x": 116,
        "y": 15.2
      },
      {
        "x": 117,
        "y": 15.2
      },
      {
        "x": 118,
        "y": 15.1
      },
      {
        "x": 118,
        "y": 15.1
      },
      {
        "x": 119,
        "y": 15.1
      },
      {
        "x": 119,
        "y": 15
      },
      {
        "x": 120,
        "y": 15
      },
      {
        "x": 120,
        "y": 15
      },
      {
        "x": 121,
        "y": 14.9
      },
      {
        "x": 121,
        "y": 14.9
      },
      {
        "x": 122,
        "y": 14.9
      },
      {
        "x": 122,
        "y": 14.8
      },
      {
        "x": 123,
        "y": 14.8
      },
      {
        "x": 123,
        "y": 14.7
      },
      {
        "x": 124,
        "y": 14.7
      },
      {
        "x": 124,
        "y": 14.7
      },
      {
        "x": 125,
        "y": 14.6
      },
      {
        "x": 125,
        "y": 14.6
      },
      {
        "x": 126,
        "y": 14.5
      },
      {
        "x": 126,
        "y": 14.5
      },
      {
        "x": 127,
        "y": 14.4
      },
      {
        "x": 127,
        "y": 14.4
      },
      {
        "x": 128,
        "y": 14.3
      },
      {
        "x": 128,
        "y": 14.3
      },
      {
        "x": 129,
        "y": 14.2
      },
      {
        "x": 130,
        "y": 14.2
      },
      {
        "x": 130,
        "y": 14.1
      },
      {
        "x": 131,
        "y": 14.1
      },
      {
        "x": 131,
        "y": 14
      },
      {
        "x": 132,
        "y": 13.9
      },
      {
        "x": 132,
        "y": 13.9
      },
      {
        "x": 133,
        "y": 13.8
      },
      {
        "x": 133,
        "y": 13.8
      },
      {
        "x": 134,
        "y": 13.7
      },
      {
        "x": 134,
        "y": 13.6
      },
      {
        "x": 134,
        "y": 13.6
      },
      {
        "x": 135,
        "y": 13.5
      },
      {
        "x": 135,
        "y": 13.4
      },
      {
        "x": 136,
        "y": 13.4
      },
      {
        "x": 136,
        "y": 13.3
      },
      {
        "x": 137,
        "y": 13.2
      },
      {
        "x": 137,
        "y": 13.2
      },
      {
        "x": 138,
        "y": 13.1
      },
      {
        "x": 138,
        "y": 13
      },
      {
        "x": 139,
        "y": 13
      },
      {
        "x": 139,
        "y": 12.9
      },
      {
        "x": 140,
        "y": 12.8
      },
      {
        "x": 140,
        "y": 12.7
      },
      {
        "x": 141,
        "y": 12.7
      },
      {
        "x": 141,
        "y": 12.6
      },
      {
        "x": 142,
        "y": 12.5
      },
      {
        "x": 142,
        "y": 12.4
      },
      {
        "x": 143,
        "y": 12.3
      },
      {
        "x": 143,
        "y": 12.3
      },
      {
        "x": 144,
        "y": 12.2
      },
      {
        "x": 144,
        "y": 12.1
      },
      {
        "x": 145,
        "y": 12
      },
      {
        "x": 145,
        "y": 11.9
      },
      {
        "x": 145,
        "y": 11.8
      },
      {
        "x": 146,
        "y": 11.8
      },
      {
        "x": 146,
        "y": 11.7
      },
      {
        "x": 147,
        "y": 11.6
      },
      {
        "x": 147,
        "y": 11.5
      },
      {
        "x": 148,
        "y": 11.4
      },
      {
        "x": 148,
        "y": 11.3
      },
      {
        "x": 149,
        "y": 11.2
      },
      {
        "x": 149,
        "y": 11.1
      },
      {
        "x": 150,
        "y": 11
      },
      {
        "x": 150,
        "y": 10.9
      },
      {
        "x": 151,
        "y": 10.9
      },
      {
        "x": 151,
        "y": 10.8
      },
      {
        "x": 151,
        "y": 10.7
      },
      {
        "x": 152,
        "y": 10.6
      },
      {
        "x": 152,
        "y": 10.5
      },
      {
        "x": 153,
        "y": 10.4
      },
      {
        "x": 153,
        "y": 10.3
      },
      {
        "x": 154,
        "y": 10.2
      },
      {
        "x": 154,
        "y": 10.1
      },
      {
        "x": 155,
        "y": 10
      },
      {
        "x": 155,
        "y": 9.9
      },
      {
        "x": 155,
        "y": 9.8
      },
      {
        "x": 156,
        "y": 9.7
      },
      {
        "x": 156,
        "y": 9.6
      },
      {
        "x": 157,
        "y": 9.4
      },
      {
        "x": 157,
        "y": 9.3
      },
      {
        "x": 158,
        "y": 9.2
      },
      {
        "x": 158,
        "y": 9.1
      },
      {
        "x": 159,
        "y": 9
      },
      {
        "x": 159,
        "y": 9
      },
      {
        "x": 159,
        "y": 8.9
      },
      {
        "x": 159,
        "y": 8.9
      },
      {
        "x": 159,
        "y": 8.8
      },
      {
        "x": 160,
        "y": 8.7
      },
      {
        "x": 160,
        "y": 8.7
      },
      {
        "x": 160,
        "y": 8.6
      },
      {
        "x": 160,
        "y": 8.6
      },
      {
        "x": 161,
        "y": 8.5
      },
      {
        "x": 161,
        "y": 8.5
      },
      {
        "x": 161,
        "y": 8.4
      },
      {
        "x": 161,
        "y": 8.4
      },
      {
        "x": 161,
        "y": 8.3
      },
      {
        "x": 162,
        "y": 8.2
      },
      {
        "x": 162,
        "y": 8.2
      },
      {
        "x": 162,
        "y": 8.1
      },
      {
        "x": 162,
        "y": 8.1
      },
      {
        "x": 163,
        "y": 8
      },
      {
        "x": 163,
        "y": 8
      },
      {
        "x": 163,
        "y": 7.9
      },
      {
        "x": 163,
        "y": 7.9
      },
      {
        "x": 163,
        "y": 7.8
      },
      {
        "x": 164,
        "y": 7.8
      },
      {
        "x": 164,
        "y": 7.7
      },
      {
        "x": 164,
        "y": 7.6
      },
      {
        "x": 164,
        "y": 7.6
      },
      {
        "x": 165,
        "y": 7.5
      },
      {
        "x": 165,
        "y": 7.5
      },
      {
        "x": 165,
        "y": 7.4
      },
      {
        "x": 165,
        "y": 7.4
      },
      {
        "x": 165,
        "y": 7.3
      },
      {
        "x": 166,
        "y": 7.3
      },
      {
        "x": 166,
        "y": 7.2
      },
      {
        "x": 166,
        "y": 7.2
      },
      {
        "x": 166,
        "y": 7.1
      },
      {
        "x": 166,
        "y": 7
      },
      {
        "x": 167,
        "y": 7
      },
      {
        "x": 167,
        "y": 6.9
      },
      {
        "x": 167,
        "y": 6.9
      },
      {
        "x": 167,
        "y": 7
      }
  ];

    // 탑뷰 차트 데이터 #3
    const topViewChartData03 =  [
      {
        "x": 0,
        "y": 0
      },
      {
        "x": 1,
        "y": 0.2
      },
      {
        "x": 2,
        "y": 0.5
      },
      {
        "x": 4,
        "y": 0.7
      },
      {
        "x": 5,
        "y": 1
      },
      {
        "x": 6,
        "y": 1.2
      },
      {
        "x": 7,
        "y": 1.4
      },
      {
        "x": 8,
        "y": 1.7
      },
      {
        "x": 9,
        "y": 1.9
      },
      {
        "x": 10,
        "y": 2.1
      },
      {
        "x": 12,
        "y": 2.4
      },
      {
        "x": 13,
        "y": 2.6
      },
      {
        "x": 14,
        "y": 2.8
      },
      {
        "x": 15,
        "y": 3
      },
      {
        "x": 16,
        "y": 3.3
      },
      {
        "x": 17,
        "y": 3.5
      },
      {
        "x": 18,
        "y": 3.7
      },
      {
        "x": 19,
        "y": 3.9
      },
      {
        "x": 20,
        "y": 4.1
      },
      {
        "x": 22,
        "y": 4.3
      },
      {
        "x": 23,
        "y": 4.5
      },
      {
        "x": 24,
        "y": 4.7
      },
      {
        "x": 25,
        "y": 4.9
      },
      {
        "x": 26,
        "y": 5.1
      },
      {
        "x": 27,
        "y": 5.3
      },
      {
        "x": 28,
        "y": 5.4
      },
      {
        "x": 29,
        "y": 5.6
      },
      {
        "x": 30,
        "y": 5.8
      },
      {
        "x": 31,
        "y": 6
      },
      {
        "x": 32,
        "y": 6.2
      },
      {
        "x": 33,
        "y": 6.3
      },
      {
        "x": 34,
        "y": 6.5
      },
      {
        "x": 35,
        "y": 6.7
      },
      {
        "x": 36,
        "y": 6.8
      },
      {
        "x": 37,
        "y": 7
      },
      {
        "x": 38,
        "y": 7.1
      },
      {
        "x": 39,
        "y": 7.3
      },
      {
        "x": 40,
        "y": 7.4
      },
      {
        "x": 41,
        "y": 7.6
      },
      {
        "x": 42,
        "y": 7.7
      },
      {
        "x": 43,
        "y": 7.9
      },
      {
        "x": 44,
        "y": 8
      },
      {
        "x": 45,
        "y": 8.2
      },
      {
        "x": 46,
        "y": 8.3
      },
      {
        "x": 47,
        "y": 8.4
      },
      {
        "x": 48,
        "y": 8.6
      },
      {
        "x": 49,
        "y": 8.7
      },
      {
        "x": 50,
        "y": 8.8
      },
      {
        "x": 50,
        "y": 8.9
      },
      {
        "x": 51,
        "y": 9.1
      },
      {
        "x": 52,
        "y": 9.2
      },
      {
        "x": 53,
        "y": 9.3
      },
      {
        "x": 54,
        "y": 9.4
      },
      {
        "x": 55,
        "y": 9.5
      },
      {
        "x": 56,
        "y": 9.6
      },
      {
        "x": 57,
        "y": 9.7
      },
      {
        "x": 58,
        "y": 9.8
      },
      {
        "x": 58,
        "y": 9.9
      },
      {
        "x": 59,
        "y": 10
      },
      {
        "x": 60,
        "y": 10.1
      },
      {
        "x": 61,
        "y": 10.2
      },
      {
        "x": 62,
        "y": 10.3
      },
      {
        "x": 63,
        "y": 10.4
      },
      {
        "x": 64,
        "y": 10.5
      },
      {
        "x": 64,
        "y": 10.6
      },
      {
        "x": 65,
        "y": 10.7
      },
      {
        "x": 66,
        "y": 10.7
      },
      {
        "x": 67,
        "y": 10.8
      },
      {
        "x": 68,
        "y": 10.9
      },
      {
        "x": 69,
        "y": 11
      },
      {
        "x": 69,
        "y": 11
      },
      {
        "x": 70,
        "y": 11.1
      },
      {
        "x": 71,
        "y": 11.2
      },
      {
        "x": 72,
        "y": 11.2
      },
      {
        "x": 73,
        "y": 11.3
      },
      {
        "x": 73,
        "y": 11.4
      },
      {
        "x": 74,
        "y": 11.4
      },
      {
        "x": 75,
        "y": 11.5
      },
      {
        "x": 76,
        "y": 11.5
      },
      {
        "x": 76,
        "y": 11.6
      },
      {
        "x": 77,
        "y": 11.6
      },
      {
        "x": 78,
        "y": 11.7
      },
      {
        "x": 79,
        "y": 11.7
      },
      {
        "x": 79,
        "y": 11.8
      },
      {
        "x": 80,
        "y": 11.8
      },
      {
        "x": 81,
        "y": 11.9
      },
      {
        "x": 82,
        "y": 11.9
      },
      {
        "x": 82,
        "y": 11.9
      },
      {
        "x": 83,
        "y": 12
      },
      {
        "x": 84,
        "y": 12
      },
      {
        "x": 85,
        "y": 12
      },
      {
        "x": 85,
        "y": 12.1
      },
      {
        "x": 86,
        "y": 12.1
      },
      {
        "x": 87,
        "y": 12.1
      },
      {
        "x": 88,
        "y": 12.1
      },
      {
        "x": 88,
        "y": 12.2
      },
      {
        "x": 89,
        "y": 12.2
      },
      {
        "x": 90,
        "y": 12.2
      },
      {
        "x": 90,
        "y": 12.2
      },
      {
        "x": 91,
        "y": 12.2
      },
      {
        "x": 92,
        "y": 12.3
      },
      {
        "x": 92,
        "y": 12.3
      },
      {
        "x": 93,
        "y": 12.3
      },
      {
        "x": 94,
        "y": 12.3
      },
      {
        "x": 94,
        "y": 12.3
      },
      {
        "x": 95,
        "y": 12.3
      },
      {
        "x": 96,
        "y": 12.3
      },
      {
        "x": 97,
        "y": 12.3
      },
      {
        "x": 97,
        "y": 12.3
      },
      {
        "x": 98,
        "y": 12.3
      },
      {
        "x": 98,
        "y": 12.3
      },
      {
        "x": 99,
        "y": 12.3
      },
      {
        "x": 100,
        "y": 12.3
      },
      {
        "x": 100,
        "y": 12.3
      },
      {
        "x": 101,
        "y": 12.3
      },
      {
        "x": 102,
        "y": 12.3
      },
      {
        "x": 102,
        "y": 12.2
      },
      {
        "x": 103,
        "y": 12.2
      },
      {
        "x": 104,
        "y": 12.2
      },
      {
        "x": 104,
        "y": 12.2
      },
      {
        "x": 105,
        "y": 12.2
      },
      {
        "x": 106,
        "y": 12.2
      },
      {
        "x": 106,
        "y": 12.1
      },
      {
        "x": 107,
        "y": 12.1
      },
      {
        "x": 107,
        "y": 12.1
      },
      {
        "x": 108,
        "y": 12.1
      },
      {
        "x": 109,
        "y": 12
      },
      {
        "x": 109,
        "y": 12
      },
      {
        "x": 110,
        "y": 12
      },
      {
        "x": 111,
        "y": 11.9
      },
      {
        "x": 111,
        "y": 11.9
      },
      {
        "x": 112,
        "y": 11.9
      },
      {
        "x": 112,
        "y": 11.8
      },
      {
        "x": 113,
        "y": 11.8
      },
      {
        "x": 114,
        "y": 11.8
      },
      {
        "x": 114,
        "y": 11.7
      },
      {
        "x": 115,
        "y": 11.7
      },
      {
        "x": 115,
        "y": 11.6
      },
      {
        "x": 116,
        "y": 11.6
      },
      {
        "x": 117,
        "y": 11.5
      },
      {
        "x": 117,
        "y": 11.5
      },
      {
        "x": 118,
        "y": 11.5
      },
      {
        "x": 118,
        "y": 11.4
      },
      {
        "x": 119,
        "y": 11.4
      },
      {
        "x": 119,
        "y": 11.3
      },
      {
        "x": 120,
        "y": 11.3
      },
      {
        "x": 121,
        "y": 11.2
      },
      {
        "x": 121,
        "y": 11.1
      },
      {
        "x": 122,
        "y": 11.1
      },
      {
        "x": 122,
        "y": 11
      },
      {
        "x": 123,
        "y": 11
      },
      {
        "x": 124,
        "y": 10.9
      },
      {
        "x": 124,
        "y": 10.8
      },
      {
        "x": 125,
        "y": 10.8
      },
      {
        "x": 125,
        "y": 10.7
      },
      {
        "x": 126,
        "y": 10.7
      },
      {
        "x": 126,
        "y": 10.6
      },
      {
        "x": 127,
        "y": 10.5
      },
      {
        "x": 127,
        "y": 10.5
      },
      {
        "x": 128,
        "y": 10.4
      },
      {
        "x": 129,
        "y": 10.3
      },
      {
        "x": 129,
        "y": 10.2
      },
      {
        "x": 130,
        "y": 10.2
      },
      {
        "x": 130,
        "y": 10.1
      },
      {
        "x": 131,
        "y": 10
      },
      {
        "x": 131,
        "y": 9.9
      },
      {
        "x": 132,
        "y": 9.9
      },
      {
        "x": 132,
        "y": 9.8
      },
      {
        "x": 133,
        "y": 9.7
      },
      {
        "x": 133,
        "y": 9.6
      },
      {
        "x": 134,
        "y": 9.5
      },
      {
        "x": 134,
        "y": 9.5
      },
      {
        "x": 135,
        "y": 9.4
      },
      {
        "x": 136,
        "y": 9.3
      },
      {
        "x": 136,
        "y": 9.2
      },
      {
        "x": 137,
        "y": 9.1
      },
      {
        "x": 137,
        "y": 9
      },
      {
        "x": 138,
        "y": 8.9
      },
      {
        "x": 138,
        "y": 8.8
      },
      {
        "x": 139,
        "y": 8.8
      },
      {
        "x": 139,
        "y": 8.7
      },
      {
        "x": 140,
        "y": 8.6
      },
      {
        "x": 140,
        "y": 8.5
      },
      {
        "x": 141,
        "y": 8.4
      },
      {
        "x": 141,
        "y": 8.3
      },
      {
        "x": 142,
        "y": 8.2
      },
      {
        "x": 142,
        "y": 8.1
      },
      {
        "x": 143,
        "y": 8
      },
      {
        "x": 143,
        "y": 7.9
      },
      {
        "x": 144,
        "y": 7.8
      },
      {
        "x": 144,
        "y": 7.7
      },
      {
        "x": 145,
        "y": 7.6
      },
      {
        "x": 145,
        "y": 7.5
      },
      {
        "x": 146,
        "y": 7.4
      },
      {
        "x": 146,
        "y": 7.2
      },
      {
        "x": 147,
        "y": 7.1
      },
      {
        "x": 147,
        "y": 7
      },
      {
        "x": 148,
        "y": 6.9
      },
      {
        "x": 148,
        "y": 6.8
      },
      {
        "x": 149,
        "y": 6.7
      },
      {
        "x": 149,
        "y": 6.6
      },
      {
        "x": 150,
        "y": 6.5
      },
      {
        "x": 150,
        "y": 6.4
      },
      {
        "x": 151,
        "y": 6.2
      },
      {
        "x": 151,
        "y": 6.1
      },
      {
        "x": 152,
        "y": 6
      },
      {
        "x": 152,
        "y": 5.9
      },
      {
        "x": 153,
        "y": 5.8
      },
      {
        "x": 153,
        "y": 5.6
      },
      {
        "x": 154,
        "y": 5.5
      },
      {
        "x": 154,
        "y": 5.4
      },
      {
        "x": 154,
        "y": 5.3
      },
      {
        "x": 154,
        "y": 5.3
      },
      {
        "x": 155,
        "y": 5.2
      },
      {
        "x": 155,
        "y": 5.2
      },
      {
        "x": 155,
        "y": 5.1
      },
      {
        "x": 155,
        "y": 5
      },
      {
        "x": 156,
        "y": 5
      },
      {
        "x": 156,
        "y": 4.9
      },
      {
        "x": 156,
        "y": 4.8
      },
      {
        "x": 156,
        "y": 4.8
      },
      {
        "x": 157,
        "y": 4.7
      },
      {
        "x": 157,
        "y": 4.7
      },
      {
        "x": 157,
        "y": 4.6
      },
      {
        "x": 157,
        "y": 4.5
      },
      {
        "x": 158,
        "y": 4.5
      },
      {
        "x": 158,
        "y": 4.4
      },
      {
        "x": 158,
        "y": 4.4
      },
      {
        "x": 158,
        "y": 4.3
      },
      {
        "x": 159,
        "y": 4.2
      },
      {
        "x": 159,
        "y": 4.2
      },
      {
        "x": 159,
        "y": 4.1
      },
      {
        "x": 159,
        "y": 4
      },
      {
        "x": 159,
        "y": 4
      },
      {
        "x": 160,
        "y": 3.9
      },
      {
        "x": 160,
        "y": 3.9
      },
      {
        "x": 160,
        "y": 3.8
      },
      {
        "x": 160,
        "y": 3.7
      },
      {
        "x": 161,
        "y": 3.7
      },
      {
        "x": 161,
        "y": 3.6
      },
      {
        "x": 161,
        "y": 3.6
      },
      {
        "x": 161,
        "y": 3.5
      },
      {
        "x": 162,
        "y": 3.4
      },
      {
        "x": 162,
        "y": 3.4
      },
      {
        "x": 162,
        "y": 3.3
      },
      {
        "x": 162,
        "y": 3.2
      },
      {
        "x": 163,
        "y": 3.2
      },
      {
        "x": 163,
        "y": 3.1
      },
      {
        "x": 163,
        "y": 3.1
      },
      {
        "x": 163,
        "y": 3
      },
      {
        "x": 164,
        "y": 2.9
      },
      {
        "x": 164,
        "y": 2.9
      },
      {
        "x": 164,
        "y": 2.8
      },
      {
        "x": 164,
        "y": 2.8
      },
      {
        "x": 164,
        "y": 2.7
      },
      {
        "x": 165,
        "y": 2.6
      },
      {
        "x": 165,
        "y": 2.6
      },
      {
        "x": 165,
        "y": 2.5
      },
      {
        "x": 165,
        "y": 2.4
      },
      {
        "x": 166,
        "y": 2.4
      },
      {
        "x": 166,
        "y": 2.3
      },
      {
        "x": 166,
        "y": 2.3
      },
      {
        "x": 166,
        "y": 2.2
      },
      {
        "x": 167,
        "y": 2.1
      },
      {
        "x": 167,
        "y": 2.1
      },
      {
        "x": 167,
        "y": 2
      },
      {
        "x": 167,
        "y": 2
      },
      {
        "x": 168,
        "y": 1.9
      },
      {
        "x": 168,
        "y": 1.8
      },
      {
        "x": 168,
        "y": 1.8
      },
      {
        "x": 168,
        "y": 1.7
      },
      {
        "x": 169,
        "y": 1.6
      },
      {
        "x": 169,
        "y": 1.6
      },
      {
        "x": 169,
        "y": 1.5
      },
      {
        "x": 169,
        "y": 1.5
      },
      {
        "x": 169,
        "y": 1.4
      },
      {
        "x": 170,
        "y": 1.3
      },
      {
        "x": 170,
        "y": 1.3
      },
      {
        "x": 170,
        "y": 1.2
      },
      {
        "x": 170,
        "y": 1.2
      },
      {
        "x": 171,
        "y": 1.1
      },
      {
        "x": 171,
        "y": 1
      },
      {
        "x": 171,
        "y": 1
      },
      {
        "x": 171,
        "y": 0.9
      },
      {
        "x": 171,
        "y": 0.9
      },
      {
        "x": 171,
        "y": 0.9
      },
      {
        "x": 171,
        "y": 0.9
      },
      {
        "x": 172,
        "y": 0.9
      },
      {
        "x": 172,
        "y": 0.8
      },
      {
        "x": 172,
        "y": 0.8
      },
      {
        "x": 172,
        "y": 0.8
      },
      {
        "x": 172,
        "y": 0.8
      },
      {
        "x": 172,
        "y": 0.8
      },
      {
        "x": 172,
        "y": 0.7
      },
      {
        "x": 172,
        "y": 0.7
      },
      {
        "x": 172,
        "y": 0.7
      },
      {
        "x": 172,
        "y": 0.7
      },
      {
        "x": 172,
        "y": 0.7
      },
      {
        "x": 172,
        "y": 0.7
      },
      {
        "x": 172,
        "y": 0.7
      },
      {
        "x": 172,
        "y": 0.6
      },
      {
        "x": 172,
        "y": 0.6
      },
      {
        "x": 172,
        "y": 0.6
      },
      {
        "x": 173,
        "y": 0.6
      },
      {
        "x": 173,
        "y": 0.6
      },
      {
        "x": 173,
        "y": 0.6
      },
      {
        "x": 173,
        "y": 0.6
      },
      {
        "x": 173,
        "y": 0.6
      },
      {
        "x": 173,
        "y": 0.5
      },
      {
        "x": 173,
        "y": 0.5
      },
      {
        "x": 173,
        "y": 0.5
      },
      {
        "x": 173,
        "y": 0.5
      },
      {
        "x": 173,
        "y": 0.5
      },
      {
        "x": 173,
        "y": 0.5
      },
      {
        "x": 173,
        "y": 0.5
      },
      {
        "x": 173,
        "y": 0.5
      },
      {
        "x": 173,
        "y": 0.5
      },
      {
        "x": 173,
        "y": 0.5
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 173,
        "y": 0.4
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.3
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.2
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      },
      {
        "x": 174,
        "y": 0.1
      }
    ] 

    // 풋뷰 차트 데이터
    const footViewChartData =  [
      {
        "x": 0,
        "y": 43.11926605504588
      },
      {
        "x": 1,
        "y": 42.592592592592595
      },
      {
        "x": 2,
        "y": 42.45283018867924
      },
      {
        "x": 3,
        "y": 42.857142857142854
      },
      {
        "x": 4,
        "y": 42.30769230769231
      },
      {
        "x": 5,
        "y": 42.71844660194174
      },
      {
        "x": 6,
        "y": 43.13725490196079
      },
      {
        "x": 7,
        "y": 43.13725490196079
      },
      {
        "x": 8,
        "y": 43.689320388349515
      },
      {
        "x": 9,
        "y": 43.689320388349515
      },
      {
        "x": 10,
        "y": 43.689320388349515
      },
      {
        "x": 11,
        "y": 44.230769230769226
      },
      {
        "x": 12,
        "y": 43.80952380952381
      },
      {
        "x": 13,
        "y": 43.925233644859816
      },
      {
        "x": 14,
        "y": 44.03669724770643
      },
      {
        "x": 15,
        "y": 43.75
      },
      {
        "x": 16,
        "y": 43.47826086956522
      },
      {
        "x": 17,
        "y": 42.73504273504273
      },
      {
        "x": 18,
        "y": 42.857142857142854
      },
      {
        "x": 19,
        "y": 42.5
      },
      {
        "x": 20,
        "y": 42.14876033057851
      },
      {
        "x": 21,
        "y": 41.80327868852459
      },
      {
        "x": 22,
        "y": 41.46341463414634
      },
      {
        "x": 23,
        "y": 41.12903225806452
      },
      {
        "x": 24,
        "y": 41.12903225806452
      },
      {
        "x": 25,
        "y": 40.8
      },
      {
        "x": 26,
        "y": 40.8
      },
      {
        "x": 27,
        "y": 41.12903225806452
      },
      {
        "x": 28,
        "y": 40.65040650406504
      },
      {
        "x": 29,
        "y": 40.65040650406504
      },
      {
        "x": 30,
        "y": 40.16393442622951
      },
      {
        "x": 31,
        "y": 40
      },
      {
        "x": 32,
        "y": 39.49579831932773
      },
      {
        "x": 33,
        "y": 38.983050847457626
      },
      {
        "x": 34,
        "y": 38.793103448275865
      },
      {
        "x": 35,
        "y": 38.26086956521739
      },
      {
        "x": 36,
        "y": 38.05309734513274
      },
      {
        "x": 37,
        "y": 38.05309734513274
      },
      {
        "x": 38,
        "y": 37.83783783783784
      },
      {
        "x": 39,
        "y": 38.18181818181819
      },
      {
        "x": 40,
        "y": 38.18181818181819
      },
      {
        "x": 41,
        "y": 38.18181818181819
      },
      {
        "x": 42,
        "y": 38.18181818181819
      },
      {
        "x": 43,
        "y": 38.18181818181819
      },
      {
        "x": 44,
        "y": 38.73873873873874
      },
      {
        "x": 45,
        "y": 38.73873873873874
      },
      {
        "x": 46,
        "y": 38.73873873873874
      },
      {
        "x": 47,
        "y": 39.285714285714285
      },
      {
        "x": 48,
        "y": 39.285714285714285
      },
      {
        "x": 49,
        "y": 39.285714285714285
      },
      {
        "x": 50,
        "y": 39.823008849557525
      },
      {
        "x": 51,
        "y": 39.823008849557525
      },
      {
        "x": 52,
        "y": 40
      },
      {
        "x": 53,
        "y": 40
      },
      {
        "x": 54,
        "y": 40
      },
      {
        "x": 55,
        "y": 40.51724137931034
      },
      {
        "x": 56,
        "y": 40.51724137931034
      },
      {
        "x": 57,
        "y": 40.51724137931034
      },
      {
        "x": 58,
        "y": 40.51724137931034
      },
      {
        "x": 59,
        "y": 40.869565217391305
      },
      {
        "x": 60,
        "y": 40.869565217391305
      },
      {
        "x": 61,
        "y": 41.37931034482759
      },
      {
        "x": 62,
        "y": 41.37931034482759
      },
      {
        "x": 63,
        "y": 41.37931034482759
      },
      {
        "x": 64,
        "y": 41.02564102564102
      },
      {
        "x": 65,
        "y": 41.02564102564102
      },
      {
        "x": 66,
        "y": 41.02564102564102
      },
      {
        "x": 67,
        "y": 41.02564102564102
      },
      {
        "x": 68,
        "y": 41.02564102564102
      },
      {
        "x": 69,
        "y": 41.37931034482759
      },
      {
        "x": 70,
        "y": 41.37931034482759
      },
      {
        "x": 71,
        "y": 41.37931034482759
      },
      {
        "x": 72,
        "y": 41.37931034482759
      },
      {
        "x": 73,
        "y": 40.869565217391305
      },
      {
        "x": 74,
        "y": 40.869565217391305
      },
      {
        "x": 75,
        "y": 40.869565217391305
      },
      {
        "x": 76,
        "y": 40.869565217391305
      },
      {
        "x": 77,
        "y": 40.869565217391305
      },
      {
        "x": 78,
        "y": 40.869565217391305
      },
      {
        "x": 79,
        "y": 40.869565217391305
      },
      {
        "x": 80,
        "y": 40.869565217391305
      },
      {
        "x": 81,
        "y": 40.869565217391305
      },
      {
        "x": 82,
        "y": 40.869565217391305
      },
      {
        "x": 83,
        "y": 40.869565217391305
      },
      {
        "x": 84,
        "y": 40.869565217391305
      },
      {
        "x": 85,
        "y": 40.869565217391305
      },
      {
        "x": 86,
        "y": 40.869565217391305
      },
      {
        "x": 87,
        "y": 40.869565217391305
      },
      {
        "x": 88,
        "y": 40.869565217391305
      },
      {
        "x": 89,
        "y": 40.869565217391305
      },
      {
        "x": 90,
        "y": 40.869565217391305
      },
      {
        "x": 91,
        "y": 40.869565217391305
      },
      {
        "x": 92,
        "y": 40.869565217391305
      },
      {
        "x": 93,
        "y": 40.869565217391305
      },
      {
        "x": 94,
        "y": 40.869565217391305
      },
      {
        "x": 95,
        "y": 41.228070175438596
      },
      {
        "x": 96,
        "y": 41.228070175438596
      },
      {
        "x": 97,
        "y": 41.228070175438596
      },
      {
        "x": 98,
        "y": 41.228070175438596
      },
      {
        "x": 99,
        "y": 41.228070175438596
      },
      {
        "x": 100,
        "y": 41.228070175438596
      },
      {
        "x": 101,
        "y": 41.228070175438596
      },
      {
        "x": 102,
        "y": 41.228070175438596
      },
      {
        "x": 103,
        "y": 41.228070175438596
      },
      {
        "x": 104,
        "y": 41.228070175438596
      },
      {
        "x": 105,
        "y": 41.228070175438596
      },
      {
        "x": 106,
        "y": 41.228070175438596
      },
      {
        "x": 107,
        "y": 41.228070175438596
      },
      {
        "x": 108,
        "y": 41.228070175438596
      },
      {
        "x": 109,
        "y": 41.228070175438596
      },
      {
        "x": 110,
        "y": 41.228070175438596
      },
      {
        "x": 111,
        "y": 41.228070175438596
      },
      {
        "x": 112,
        "y": 41.228070175438596
      },
      {
        "x": 113,
        "y": 41.228070175438596
      },
      {
        "x": 114,
        "y": 41.228070175438596
      },
      {
        "x": 115,
        "y": 41.228070175438596
      },
      {
        "x": 116,
        "y": 41.228070175438596
      },
      {
        "x": 117,
        "y": 41.228070175438596
      },
      {
        "x": 118,
        "y": 41.228070175438596
      },
      {
        "x": 119,
        "y": 41.228070175438596
      },
      {
        "x": 120,
        "y": 41.73913043478261
      },
      {
        "x": 121,
        "y": 41.73913043478261
      },
      {
        "x": 122,
        "y": 41.73913043478261
      },
      {
        "x": 123,
        "y": 41.73913043478261
      },
      {
        "x": 124,
        "y": 41.73913043478261
      },
      {
        "x": 125,
        "y": 41.73913043478261
      },
      {
        "x": 126,
        "y": 42.10526315789473
      },
      {
        "x": 127,
        "y": 42.10526315789473
      },
      {
        "x": 128,
        "y": 42.10526315789473
      },
      {
        "x": 129,
        "y": 42.10526315789473
      },
      {
        "x": 130,
        "y": 42.10526315789473
      },
      {
        "x": 131,
        "y": 42.10526315789473
      },
      {
        "x": 132,
        "y": 42.10526315789473
      },
      {
        "x": 133,
        "y": 42.10526315789473
      },
      {
        "x": 134,
        "y": 42.10526315789473
      },
      {
        "x": 135,
        "y": 42.10526315789473
      },
      {
        "x": 136,
        "y": 42.10526315789473
      },
      {
        "x": 137,
        "y": 42.10526315789473
      },
      {
        "x": 138,
        "y": 42.10526315789473
      },
      {
        "x": 139,
        "y": 42.10526315789473
      },
      {
        "x": 140,
        "y": 42.10526315789473
      },
      {
        "x": 141,
        "y": 42.10526315789473
      },
      {
        "x": 142,
        "y": 42.10526315789473
      },
      {
        "x": 143,
        "y": 42.10526315789473
      },
      {
        "x": 144,
        "y": 42.608695652173914
      },
      {
        "x": 145,
        "y": 42.608695652173914
      },
      {
        "x": 146,
        "y": 42.608695652173914
      },
      {
        "x": 147,
        "y": 42.608695652173914
      },
      {
        "x": 148,
        "y": 42.608695652173914
      },
      {
        "x": 149,
        "y": 42.608695652173914
      },
      {
        "x": 150,
        "y": 42.608695652173914
      },
      {
        "x": 151,
        "y": 42.608695652173914
      },
      {
        "x": 152,
        "y": 42.608695652173914
      },
      {
        "x": 153,
        "y": 42.608695652173914
      },
      {
        "x": 154,
        "y": 42.608695652173914
      },
      {
        "x": 155,
        "y": 42.608695652173914
      },
      {
        "x": 156,
        "y": 42.98245614035088
      },
      {
        "x": 157,
        "y": 42.98245614035088
      },
      {
        "x": 158,
        "y": 42.47787610619469
      },
      {
        "x": 159,
        "y": 42.47787610619469
      },
      {
        "x": 160,
        "y": 42.47787610619469
      },
      {
        "x": 161,
        "y": 42.47787610619469
      },
      {
        "x": 162,
        "y": 42.47787610619469
      },
      {
        "x": 163,
        "y": 42.47787610619469
      },
      {
        "x": 164,
        "y": 42.47787610619469
      },
      {
        "x": 165,
        "y": 42.47787610619469
      },
      {
        "x": 166,
        "y": 42.47787610619469
      },
      {
        "x": 167,
        "y": 42.47787610619469
      },
      {
        "x": 168,
        "y": 42.47787610619469
      },
      {
        "x": 169,
        "y": 42.47787610619469
      },
      {
        "x": 170,
        "y": 42.47787610619469
      },
      {
        "x": 171,
        "y": 42.47787610619469
      },
      {
        "x": 172,
        "y": 42.47787610619469
      },
      {
        "x": 173,
        "y": 42.47787610619469
      },
      {
        "x": 174,
        "y": 42.47787610619469
      },
      {
        "x": 175,
        "y": 42.47787610619469
      },
      {
        "x": 176,
        "y": 42.47787610619469
      },
      {
        "x": 177,
        "y": 42.47787610619469
      },
      {
        "x": 178,
        "y": 42.47787610619469
      },
      {
        "x": 179,
        "y": 42.10526315789473
      },
      {
        "x": 180,
        "y": 42.10526315789473
      },
      {
        "x": 181,
        "y": 42.10526315789473
      },
      {
        "x": 182,
        "y": 42.10526315789473
      },
      {
        "x": 183,
        "y": 42.10526315789473
      },
      {
        "x": 184,
        "y": 42.10526315789473
      },
      {
        "x": 185,
        "y": 42.10526315789473
      },
      {
        "x": 186,
        "y": 42.10526315789473
      },
      {
        "x": 187,
        "y": 42.10526315789473
      },
      {
        "x": 188,
        "y": 41.5929203539823
      },
      {
        "x": 189,
        "y": 41.5929203539823
      },
      {
        "x": 190,
        "y": 41.5929203539823
      },
      {
        "x": 191,
        "y": 41.228070175438596
      },
      {
        "x": 192,
        "y": 41.228070175438596
      },
      {
        "x": 193,
        "y": 40.707964601769916
      },
      {
        "x": 194,
        "y": 40.707964601769916
      },
      {
        "x": 195,
        "y": 40.707964601769916
      },
      {
        "x": 196,
        "y": 40.707964601769916
      },
      {
        "x": 197,
        "y": 40.707964601769916
      },
      {
        "x": 198,
        "y": 40.35087719298245
      },
      {
        "x": 199,
        "y": 39.823008849557525
      },
      {
        "x": 200,
        "y": 39.823008849557525
      },
      {
        "x": 201,
        "y": 39.473684210526315
      },
      {
        "x": 202,
        "y": 38.93805309734513
      },
      {
        "x": 203,
        "y": 38.93805309734513
      },
      {
        "x": 204,
        "y": 38.59649122807017
      },
      {
        "x": 205,
        "y": 38.05309734513274
      },
      {
        "x": 206,
        "y": 37.719298245614034
      },
      {
        "x": 207,
        "y": 37.719298245614034
      },
      {
        "x": 208,
        "y": 37.391304347826086
      },
      {
        "x": 209,
        "y": 37.06896551724138
      },
      {
        "x": 210,
        "y": 36.52173913043478
      },
      {
        "x": 211,
        "y": 36.206896551724135
      },
      {
        "x": 212,
        "y": 35.65217391304348
      },
      {
        "x": 213,
        "y": 35.65217391304348
      },
      {
        "x": 214,
        "y": 35.08771929824561
      },
      {
        "x": 215,
        "y": 34.21052631578947
      },
      {
        "x": 216,
        "y": 34.21052631578947
      },
      {
        "x": 217,
        "y": 33.33333333333333
      },
      {
        "x": 218,
        "y": 33.33333333333333
      },
      {
        "x": 219,
        "y": 33.04347826086956
      },
      {
        "x": 220,
        "y": 32.45614035087719
      },
      {
        "x": 221,
        "y": 32.17391304347826
      },
      {
        "x": 222,
        "y": 31.57894736842105
      },
      {
        "x": 223,
        "y": 30.701754385964914
      },
      {
        "x": 224,
        "y": 30.701754385964914
      },
      {
        "x": 225,
        "y": 30.08849557522124
      },
      {
        "x": 226,
        "y": 30.08849557522124
      },
      {
        "x": 227,
        "y": 29.20353982300885
      },
      {
        "x": 228,
        "y": 29.20353982300885
      },
      {
        "x": 229,
        "y": 29.20353982300885
      },
      {
        "x": 230,
        "y": 28.57142857142857
      },
      {
        "x": 231,
        "y": 28.31858407079646
      },
      {
        "x": 232,
        "y": 28.31858407079646
      },
      {
        "x": 233,
        "y": 27.67857142857143
      },
      {
        "x": 234,
        "y": 27.67857142857143
      },
      {
        "x": 235,
        "y": 27.67857142857143
      },
      {
        "x": 236,
        "y": 27.67857142857143
      },
      {
        "x": 237,
        "y": 27.67857142857143
      },
      {
        "x": 238,
        "y": 27.027027027027028
      },
      {
        "x": 239,
        "y": 27.027027027027028
      },
      {
        "x": 240,
        "y": 27.027027027027028
      },
      {
        "x": 241,
        "y": 27.927927927927925
      },
      {
        "x": 242,
        "y": 27.927927927927925
      },
      {
        "x": 243,
        "y": 27.927927927927925
      },
      {
        "x": 244,
        "y": 27.927927927927925
      },
      {
        "x": 245,
        "y": 27.927927927927925
      },
      {
        "x": 246,
        "y": 27.927927927927925
      },
      {
        "x": 247,
        "y": 27.927927927927925
      },
      {
        "x": 248,
        "y": 27.927927927927925
      },
      {
        "x": 249,
        "y": 27.927927927927925
      },
      {
        "x": 250,
        "y": 27.927927927927925
      },
      {
        "x": 251,
        "y": 28.82882882882883
      },
      {
        "x": 252,
        "y": 28.82882882882883
      },
      {
        "x": 253,
        "y": 28.82882882882883
      },
      {
        "x": 254,
        "y": 28.82882882882883
      },
      {
        "x": 255,
        "y": 28.82882882882883
      },
      {
        "x": 256,
        "y": 28.82882882882883
      },
      {
        "x": 257,
        "y": 28.82882882882883
      },
      {
        "x": 258,
        "y": 28.82882882882883
      },
      {
        "x": 259,
        "y": 28.82882882882883
      },
      {
        "x": 260,
        "y": 28.82882882882883
      },
      {
        "x": 261,
        "y": 28.82882882882883
      },
      {
        "x": 262,
        "y": 28.82882882882883
      },
      {
        "x": 263,
        "y": 28.82882882882883
      },
      {
        "x": 264,
        "y": 28.82882882882883
      },
      {
        "x": 265,
        "y": 29.09090909090909
      },
      {
        "x": 266,
        "y": 28.440366972477065
      },
      {
        "x": 267,
        "y": 28.440366972477065
      },
      {
        "x": 268,
        "y": 28.440366972477065
      },
      {
        "x": 269,
        "y": 28.440366972477065
      },
      {
        "x": 270,
        "y": 28.440366972477065
      },
      {
        "x": 271,
        "y": 27.77777777777778
      },
      {
        "x": 272,
        "y": 27.77777777777778
      },
      {
        "x": 273,
        "y": 27.522935779816514
      },
      {
        "x": 274,
        "y": 26.851851851851855
      },
      {
        "x": 275,
        "y": 26.851851851851855
      },
      {
        "x": 276,
        "y": 25.925925925925924
      },
      {
        "x": 277,
        "y": 25.925925925925924
      },
      {
        "x": 278,
        "y": 25.233644859813083
      },
      {
        "x": 279,
        "y": 25
      },
      {
        "x": 280,
        "y": 24.299065420560748
      },
      {
        "x": 281,
        "y": 24.074074074074073
      },
      {
        "x": 282,
        "y": 23.364485981308412
      },
      {
        "x": 283,
        "y": 22.641509433962266
      },
      {
        "x": 284,
        "y": 21.69811320754717
      },
      {
        "x": 285,
        "y": 20.952380952380953
      },
      {
        "x": 286,
        "y": 20.952380952380953
      },
      {
        "x": 287,
        "y": 20.192307692307693
      },
      {
        "x": 288,
        "y": 19.230769230769234
      },
      {
        "x": 289,
        "y": 18.446601941747574
      },
      {
        "x": 290,
        "y": 17.647058823529413
      },
      {
        "x": 291,
        "y": 16.666666666666664
      },
      {
        "x": 292,
        "y": 15.841584158415841
      },
      {
        "x": 293,
        "y": 15.841584158415841
      },
      {
        "x": 294,
        "y": 15
      },
      {
        "x": 295,
        "y": 14.85148514851485
      },
      {
        "x": 296,
        "y": 14.000000000000002
      },
      {
        "x": 297,
        "y": 14.000000000000002
      },
      {
        "x": 298,
        "y": 14.000000000000002
      },
      {
        "x": 299,
        "y": 14.000000000000002
      },
      {
        "x": 300,
        "y": 14.000000000000002
      },
      {
        "x": 301,
        "y": 13.131313131313133
      },
      {
        "x": 302,
        "y": 13.131313131313133
      },
      {
        "x": 303,
        "y": 13.131313131313133
      },
      {
        "x": 304,
        "y": 13.131313131313133
      },
      {
        "x": 305,
        "y": 13
      },
      {
        "x": 306,
        "y": 13.861386138613863
      },
      {
        "x": 307,
        "y": 13.861386138613863
      },
      {
        "x": 308,
        "y": 13.861386138613863
      },
      {
        "x": 309,
        "y": 13.861386138613863
      },
      {
        "x": 310,
        "y": 14.705882352941178
      },
      {
        "x": 311,
        "y": 14.705882352941178
      },
      {
        "x": 312,
        "y": 15.53398058252427
      },
      {
        "x": 313,
        "y": 16.346153846153847
      },
      {
        "x": 314,
        "y": 17.92452830188679
      },
      {
        "x": 315,
        "y": 19.444444444444446
      },
      {
        "x": 316,
        "y": 21.62162162162162
      },
      {
        "x": 317,
        "y": 24.347826086956523
      },
      {
        "x": 318,
        "y": 27.11864406779661
      },
      {
        "x": 319,
        "y": 29.75206611570248
      },
      {
        "x": 320,
        "y": 33.064516129032256
      },
      {
        "x": 321,
        "y": 36.22047244094488
      },
      {
        "x": 322,
        "y": 39.0625
      },
      {
        "x": 323,
        "y": 41.40625
      },
      {
        "x": 324,
        "y": 42.857142857142854
      },
      {
        "x": 325,
        "y": 44
      },
      {
        "x": 326,
        "y": 44.71544715447154
      },
      {
        "x": 327,
        "y": 45.90163934426229
      },
      {
        "x": 328,
        "y": 47.540983606557376
      },
      {
        "x": 329,
        "y": 49.166666666666664
      },
      {
        "x": 330,
        "y": 50.83333333333333
      },
      {
        "x": 331,
        "y": 52.54237288135594
      },
      {
        "x": 332,
        "y": 53.84615384615385
      },
      {
        "x": 333,
        "y": 55.65217391304348
      },
      {
        "x": 334,
        "y": 57.01754385964912
      },
      {
        "x": 335,
        "y": 58.4070796460177
      },
      {
        "x": 336,
        "y": 60.17699115044248
      },
      {
        "x": 337,
        "y": 61.60714285714286
      },
      {
        "x": 338,
        "y": 63.39285714285714
      },
      {
        "x": 339,
        "y": 64.86486486486487
      },
      {
        "x": 340,
        "y": 65.45454545454545
      },
      {
        "x": 341,
        "y": 66.05504587155964
      },
      {
        "x": 342,
        "y": 64.54545454545455
      },
      {
        "x": 343,
        "y": 63.39285714285714
      },
      {
        "x": 344,
        "y": 61.94690265486725
      },
      {
        "x": 345,
        "y": 61.06194690265486
      },
      {
        "x": 346,
        "y": 60.71428571428571
      },
      {
        "x": 347,
        "y": 61.111111111111114
      },
      {
        "x": 348,
        "y": 60.57692307692307
      },
      {
        "x": 349,
        "y": 59
      },
      {
        "x": 350,
        "y": 56.12244897959183
      },
      {
        "x": 351,
        "y": 53.608247422680414
      },
      {
        "x": 352,
        "y": 51.578947368421055
      },
      {
        "x": 353,
        "y": 50
      },
      {
        "x": 354,
        "y": 49.43820224719101
      },
      {
        "x": 355,
        "y": 47.05882352941176
      },
      {
        "x": 356,
        "y": 43.90243902439025
      },
      {
        "x": 357,
        "y": 40
      },
      {
        "x": 358,
        "y": 37.5
      },
      {
        "x": 359,
        "y": 37.03703703703704
      },
      {
        "x": 360,
        "y": 38.55421686746988
      },
      {
        "x": 361,
        "y": 41.17647058823529
      },
      {
        "x": 362,
        "y": 43.82022471910113
      },
      {
        "x": 363,
        "y": 45.65217391304348
      },
      {
        "x": 364,
        "y": 46.875
      },
      {
        "x": 365,
        "y": 46.93877551020408
      },
      {
        "x": 366,
        "y": 45.91836734693878
      },
      {
        "x": 367,
        "y": 43.87755102040816
      },
      {
        "x": 368,
        "y": 42.2680412371134
      },
      {
        "x": 369,
        "y": 41.23711340206185
      },
      {
        "x": 370,
        "y": 39.175257731958766
      },
      {
        "x": 371,
        "y": 38.775510204081634
      },
      {
        "x": 372,
        "y": 38
      },
      {
        "x": 373,
        "y": 37.62376237623762
      },
      {
        "x": 374,
        "y": 37.86407766990291
      },
      {
        "x": 375,
        "y": 37.5
      },
      {
        "x": 376,
        "y": 36.79245283018868
      },
      {
        "x": 377,
        "y": 36.69724770642202
      },
      {
        "x": 378,
        "y": 36.607142857142854
      },
      {
        "x": 379,
        "y": 36.84210526315789
      },
      {
        "x": 380,
        "y": 36.52173913043478
      },
      {
        "x": 381,
        "y": 37.06896551724138
      },
      {
        "x": 382,
        "y": 36.52173913043478
      },
      {
        "x": 383,
        "y": 35.08771929824561
      },
      {
        "x": 384,
        "y": 34.51327433628318
      },
      {
        "x": 385,
        "y": 33.33333333333333
      },
      {
        "x": 386,
        "y": 33.33333333333333
      },
      {
        "x": 387,
        "y": 32.72727272727273
      },
      {
        "x": 388,
        "y": 31.818181818181817
      },
      {
        "x": 389,
        "y": 31.818181818181817
      },
      {
        "x": 390,
        "y": 31.818181818181817
      },
      {
        "x": 391,
        "y": 30.909090909090907
      },
      {
        "x": 392,
        "y": 30.909090909090907
      },
      {
        "x": 393,
        "y": 29.357798165137616
      },
      {
        "x": 394,
        "y": 28.037383177570092
      },
      {
        "x": 395,
        "y": 27.358490566037734
      },
      {
        "x": 396,
        "y": 26.41509433962264
      },
      {
        "x": 397,
        "y": 26.41509433962264
      },
      {
        "x": 398,
        "y": 26.41509433962264
      },
      {
        "x": 399,
        "y": 27.102803738317753
      },
      {
        "x": 400,
        "y": 27.102803738317753
      },
      {
        "x": 401,
        "y": 27.102803738317753
      },
      {
        "x": 402,
        "y": 27.102803738317753
      },
      {
        "x": 403,
        "y": 26.41509433962264
      },
      {
        "x": 404,
        "y": 26.41509433962264
      },
      {
        "x": 405,
        "y": 25
      },
      {
        "x": 406,
        "y": 25
      },
      {
        "x": 407,
        "y": 24.271844660194176
      },
      {
        "x": 408,
        "y": 24.271844660194176
      },
      {
        "x": 409,
        "y": 25
      },
      {
        "x": 410,
        "y": 25
      },
      {
        "x": 411,
        "y": 25
      },
      {
        "x": 412,
        "y": 25.71428571428571
      },
      {
        "x": 413,
        "y": 25.471698113207548
      },
      {
        "x": 414,
        "y": 25.471698113207548
      },
      {
        "x": 415,
        "y": 25.471698113207548
      },
      {
        "x": 416,
        "y": 25.471698113207548
      },
      {
        "x": 417,
        "y": 25.471698113207548
      },
      {
        "x": 418,
        "y": 25.471698113207548
      },
      {
        "x": 419,
        "y": 25.471698113207548
      },
      {
        "x": 420,
        "y": 25.471698113207548
      },
      {
        "x": 421,
        "y": 26.168224299065418
      },
      {
        "x": 422,
        "y": 26.168224299065418
      },
      {
        "x": 423,
        "y": 26.851851851851855
      },
      {
        "x": 424,
        "y": 26.851851851851855
      },
      {
        "x": 425,
        "y": 26.851851851851855
      },
      {
        "x": 426,
        "y": 26.605504587155966
      },
      {
        "x": 427,
        "y": 26.605504587155966
      },
      {
        "x": 428,
        "y": 25.688073394495415
      },
      {
        "x": 429,
        "y": 24.074074074074073
      },
      {
        "x": 430,
        "y": 22.429906542056074
      },
      {
        "x": 431,
        "y": 20
      },
      {
        "x": 432,
        "y": 16.666666666666664
      },
      {
        "x": 433,
        "y": 14.000000000000002
      },
      {
        "x": 434,
        "y": 12.121212121212121
      },
      {
        "x": 435,
        "y": 9.278350515463918
      },
      {
        "x": 436,
        "y": 7.368421052631578
      },
      {
        "x": 437,
        "y": 4.301075268817205
      },
      {
        "x": 438,
        "y": 2.197802197802198
      },
      {
        "x": 439,
        "y": 0
      },
      {
        "x": 440,
        "y": 0
      },
      {
        "x": 441,
        "y": 1.1111111111111112
      },
      {
        "x": 442,
        "y": 1.1111111111111112
      },
      {
        "x": 443,
        "y": 2.197802197802198
      },
      {
        "x": 444,
        "y": 1.1111111111111112
      },
      {
        "x": 445,
        "y": 1.1111111111111112
      },
      {
        "x": 446,
        "y": 1.1235955056179776
      },
      {
        "x": 447,
        "y": 1.1235955056179776
      },
      {
        "x": 448,
        "y": 2.247191011235955
      },
      {
        "x": 449,
        "y": 3.4090909090909087
      },
      {
        "x": 450,
        "y": 3.488372093023256
      },
      {
        "x": 451,
        "y": 3.571428571428571
      },
      {
        "x": 452,
        "y": 6.024096385542169
      },
      {
        "x": 453,
        "y": 12.941176470588237
      },
      {
        "x": 454,
        "y": 23.655913978494624
      },
      {
        "x": 455,
        "y": 33.33333333333333
      },
      {
        "x": 456,
        "y": 40
      },
      {
        "x": 457,
        "y": 44.34782608695652
      },
      {
        "x": 458,
        "y": 47.008547008547005
      },
      {
        "x": 459,
        "y": 50.427350427350426
      },
      {
        "x": 460,
        "y": 54.700854700854705
      },
      {
        "x": 461,
        "y": 59.66386554621849
      },
      {
        "x": 462,
        "y": 64.46280991735537
      },
      {
        "x": 463,
        "y": 68.29268292682927
      },
      {
        "x": 464,
        "y": 70.96774193548387
      },
      {
        "x": 465,
        "y": 74.19354838709677
      },
      {
        "x": 466,
        "y": 76.61290322580645
      },
      {
        "x": 467,
        "y": 78.4
      },
      {
        "x": 468,
        "y": 79.03225806451613
      },
      {
        "x": 469,
        "y": 78.68852459016394
      },
      {
        "x": 470,
        "y": 78.99159663865547
      },
      {
        "x": 471,
        "y": 80
      },
      {
        "x": 472,
        "y": 81.25
      },
      {
        "x": 473,
        "y": 82.56880733944955
      },
      {
        "x": 474,
        "y": 82.4074074074074
      },
      {
        "x": 475,
        "y": 81.48148148148148
      },
      {
        "x": 476,
        "y": 79.81651376146789
      },
      {
        "x": 477,
        "y": 79.81651376146789
      },
      {
        "x": 478,
        "y": 79.62962962962963
      },
      {
        "x": 479,
        "y": 80.18867924528303
      },
      {
        "x": 480,
        "y": 80.19801980198021
      },
      {
        "x": 481,
        "y": 79.59183673469387
      },
      {
        "x": 482,
        "y": 78.125
      },
      {
        "x": 483,
        "y": 77.89473684210526
      },
      {
        "x": 484,
        "y": 77.41935483870968
      },
      {
        "x": 485,
        "y": 76.92307692307693
      },
      {
        "x": 486,
        "y": 76.40449438202246
      },
      {
        "x": 487,
        "y": 75.86206896551724
      },
      {
        "x": 488,
        "y": 75.5813953488372
      },
      {
        "x": 489,
        "y": 75.29411764705883
      },
      {
        "x": 490,
        "y": 75.29411764705883
      },
      {
        "x": 491,
        "y": 75
      },
      {
        "x": 492,
        "y": 74.69879518072288
      },
      {
        "x": 493,
        "y": 74.69879518072288
      },
      {
        "x": 494,
        "y": 74.69879518072288
      },
      {
        "x": 495,
        "y": 74.39024390243902
      },
      {
        "x": 496,
        "y": 74.39024390243902
      },
      {
        "x": 497,
        "y": 74.39024390243902
      },
      {
        "x": 498,
        "y": 74.07407407407408
      },
      {
        "x": 499,
        "y": 74.39024390243902
      },
      {
        "x": 500,
        "y": 74.39024390243902
      },
      {
        "x": 501,
        "y": 75.30864197530865
      },
      {
        "x": 502,
        "y": 74.69879518072288
      },
      {
        "x": 503,
        "y": 74.69879518072288
      },
      {
        "x": 504,
        "y": 75
      },
      {
        "x": 505,
        "y": 75
      },
      {
        "x": 506,
        "y": 76.19047619047619
      },
      {
        "x": 507,
        "y": 76.47058823529412
      },
      {
        "x": 508,
        "y": 76.47058823529412
      },
      {
        "x": 509,
        "y": 76.74418604651163
      },
      {
        "x": 510,
        "y": 77.01149425287356
      },
      {
        "x": 511,
        "y": 77.01149425287356
      },
      {
        "x": 512,
        "y": 77.27272727272727
      },
      {
        "x": 513,
        "y": 77.27272727272727
      },
      {
        "x": 514,
        "y": 77.27272727272727
      },
      {
        "x": 515,
        "y": 77.27272727272727
      },
      {
        "x": 516,
        "y": 77.01149425287356
      },
      {
        "x": 517,
        "y": 77.01149425287356
      },
      {
        "x": 518,
        "y": 76.74418604651163
      },
      {
        "x": 519,
        "y": 75.86206896551724
      },
      {
        "x": 520,
        "y": 75.5813953488372
      },
      {
        "x": 521,
        "y": 76.47058823529412
      },
      {
        "x": 522,
        "y": 76.19047619047619
      },
      {
        "x": 523,
        "y": 75.29411764705883
      },
      {
        "x": 524,
        "y": 75
      },
      {
        "x": 525,
        "y": 75
      },
      {
        "x": 526,
        "y": 75
      },
      {
        "x": 527,
        "y": 75
      },
      {
        "x": 528,
        "y": 75
      },
      {
        "x": 529,
        "y": 75
      },
      {
        "x": 530,
        "y": 75
      },
      {
        "x": 531,
        "y": 75
      },
      {
        "x": 532,
        "y": 75
      },
      {
        "x": 533,
        "y": 74.69879518072288
      },
      {
        "x": 534,
        "y": 74.69879518072288
      },
      {
        "x": 535,
        "y": 74.69879518072288
      },
      {
        "x": 536,
        "y": 75
      },
      {
        "x": 537,
        "y": 75
      },
      {
        "x": 538,
        "y": 75
      },
      {
        "x": 539,
        "y": 75
      },
      {
        "x": 540,
        "y": 75
      },
      {
        "x": 541,
        "y": 75.29411764705883
      },
      {
        "x": 542,
        "y": 75.29411764705883
      },
      {
        "x": 543,
        "y": 75.29411764705883
      },
      {
        "x": 544,
        "y": 75
      },
      {
        "x": 545,
        "y": 75
      },
      {
        "x": 546,
        "y": 74.69879518072288
      },
      {
        "x": 547,
        "y": 74.39024390243902
      },
      {
        "x": 548,
        "y": 73.75
      },
      {
        "x": 549,
        "y": 73.07692307692307
      },
      {
        "x": 550,
        "y": 72.36842105263158
      },
      {
        "x": 551,
        "y": 71.23287671232876
      },
      {
        "x": 552,
        "y": 70.4225352112676
      },
      {
        "x": 553,
        "y": 69.11764705882352
      },
      {
        "x": 554,
        "y": 67.1875
      },
      {
        "x": 555,
        "y": 65
      },
      {
        "x": 556,
        "y": 62.5
      },
      {
        "x": 557,
        "y": 58.82352941176471
      },
      {
        "x": 558,
        "y": 56.25
      },
      {
        "x": 559,
        "y": 53.333333333333336
      },
      {
        "x": 560,
        "y": 51.162790697674424
      },
      {
        "x": 561,
        "y": 48.78048780487805
      },
      {
        "x": 562,
        "y": 47.5
      },
      {
        "x": 563,
        "y": 43.58974358974359
      },
      {
        "x": 564,
        "y": 42.10526315789473
      },
      {
        "x": 565,
        "y": 40
      },
      {
        "x": 566,
        "y": 34.375
      },
      {
        "x": 567,
        "y": 30
      },
      {
        "x": 568,
        "y": 27.586206896551722
      },
      {
        "x": 569,
        "y": 22.22222222222222
      },
      {
        "x": 570,
        "y": 19.230769230769234
      },
      {
        "x": 571,
        "y": 16
      },
      {
        "x": 572,
        "y": 12.5
      },
      {
        "x": 573,
        "y": 8.695652173913043
      },
      {
        "x": 574,
        "y": 4.545454545454546
      },
      {
        "x": 575,
        "y": 4.545454545454546
      },
      {
        "x": 576,
        "y": 0
      },
      {
        "x": 577,
        "y": 0
      },
      {
        "x": 578,
        "y": 4.545454545454546
      },
      {
        "x": 579,
        "y": 4.545454545454546
      },
      {
        "x": 580,
        "y": 4.545454545454546
      },
      {
        "x": 581,
        "y": 4.545454545454546
      },
      {
        "x": 582,
        "y": 4.545454545454546
      },
      {
        "x": 583,
        "y": 4.545454545454546
      },
      {
        "x": 584,
        "y": 4.545454545454546
      },
      {
        "x": 585,
        "y": 4.545454545454546
      },
      {
        "x": 586,
        "y": 4.545454545454546
      },
      {
        "x": 587,
        "y": 4.545454545454546
      },
      {
        "x": 588,
        "y": 4.545454545454546
      },
      {
        "x": 589,
        "y": 4.545454545454546
      },
      {
        "x": 590,
        "y": 4.545454545454546
      },
      {
        "x": 591,
        "y": 4.545454545454546
      },
      {
        "x": 592,
        "y": 4.545454545454546
      },
      {
        "x": 593,
        "y": 4.545454545454546
      },
      {
        "x": 594,
        "y": 4.545454545454546
      },
      {
        "x": 595,
        "y": 4.545454545454546
      },
      {
        "x": 596,
        "y": 4.545454545454546
      },
      {
        "x": 597,
        "y": 4.545454545454546
      },
      {
        "x": 598,
        "y": 4.545454545454546
      },
      {
        "x": 599,
        "y": 4.545454545454546
      }
    ]; 

    // 사이드뷰 차트 옵션
    const sideViewChartOption = {
      dataset: [
        { source: sideViewChartData01 },
        { source: sideViewChartData02 },
        { source: sideViewChartData03 }
      ], // 데이터값
      grid: {
        top: 10,
        bottom: 0,
        left: 0,
        right: 10,
        containLabel: true // 라벨 표시여부
      }, // 그리드 설정
      tooltip: {
        trigger: 'axis', // 툴팁 종류
        formatter: function (params) {
          const [sideShotData01, sideShotData02, sideShotData03] = params || [];
          const getValue = (data, key) => (data && data[key] !== undefined ? data[key] : '-');
          return `
            <div style="padding:6px 10px; text-align: left;">
              <div style="font-weight:bold; margin-bottom:4px; color: #ff0000;">#1</div>
              <div><strong>수평점</strong>: <span>${getValue(sideShotData01?.data, 'x')}m</span></div>
              <div><strong>수직점</strong>: <span>${parseInt(getValue(sideShotData01?.data, 'y'))}m</span></div>
              <br>
              <div style="font-weight:bold; margin-bottom:4px; color: #00aa00;">#2</div>
              <div><strong>수평점</strong>: <span>${getValue(sideShotData02?.data, 'x')}m</span></div>
              <div><strong>수직점</strong>: <span>${parseInt(getValue(sideShotData02?.data, 'y'))}m</span></div>
              <br>
              <div style="font-weight:bold; margin-bottom:4px; color: #0000ff;">#3</div>
              <div><strong>수평점</strong>: <span>${getValue(sideShotData03?.data, 'x')}m</span></div>
              <div><strong>수직점</strong>: <span>${parseInt(getValue(sideShotData03?.data, 'y'))}m</span></div>
            </div>
          `;
        }
      }, // 툴팁 설정
      xAxis: {
        type: 'value', // 숫자형
        max: 300, // 최댓값
        axisLine: { show: false }, // 축선 여부
        axisTick: { show: false }, // 축 눈금선 여부
        splitLine: {
          show: true,
          lineStyle: { 
            type: 'solid', // 유형
            color: '#ccc', // 컬러
            width: 1 // 굵기 
          } // 라인 스타일
        }, // 보조선(격자선) 여부
        boundaryGap: true // 축 여백
      }, // x축 설정
      yAxis: {
        type: 'value', // 숫자형
        min: 0, // 최솟값
        axisLine: { show: false }, // 축선 여부
        axisTick: { show: false }, // 축 눈금선 여부
        splitLine: { show: true }, // 보조선(격자선) 여부
      }, // y축 설정
      series: [
        {
          name: '#1', // 이름
          type: 'line', // 차트 종류
          datasetIndex: 0, // 사용할 데이터셋 지정
          encode: { x: 'x', y: 'y' }, // 데이터 매핑
          smooth: true, // 선을 부드럽게
          symbol: 'circle', // 점 모양
          showSymbol: false, // 점 여부
          emphasis: {
            focus: 'series',
          }, // 마우스 호버시
          itemStyle: {
            color: '#ff0000'
          }, // 스타일
          lineStyle: {
            width: 2
          }, // 선 스타일
        },
        {
          name: '#2',
          type: 'line',
          datasetIndex: 1,
          encode: { x: 'x', y: 'y' },
          smooth: true,
          symbol: 'circle',
          showSymbol: false,
          emphasis: {
            focus: 'series'
          },
          itemStyle: { color: '#00aa00' },
          lineStyle: {
            width: 2
          },
          },
        {
          name: '#3',
          type: 'line',
          datasetIndex: 2,
          encode: { x: 'x', y: 'y' },
          smooth: true,
          symbol: 'circle',
          showSymbol: false,
          emphasis: {
            focus: 'series'
          },
          itemStyle: { color: '#0000ff' },
          lineStyle: {
            width: 2
          },
        }
      ] // 데이터 정의
    };
    
    // 탑뷰 차트 옵션
    const topViewChartOption = {
      dataset: [
        { source: topViewChartData01 },
        { source: topViewChartData02 },
        { source: topViewChartData03 }
      ],
      grid: {
        top: 10, bottom: 0, left: 0, right: 10, containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params) {
          return `
            <div style="padding:6px 10px; text-align: left;">
              <div style="font-weight:bold; margin-bottom:4px; color: #ff0000;">#1</div>
              <div><strong>수평점</strong>: <span>${params[0]?.data?.x ?? '-'}m</span></div>
              <div><strong>수직점</strong>: <span>${params[0]?.data?.y !== undefined ? parseInt(params[0].data.y) : '-'}m</span></div>
              <br>
              <div style="font-weight:bold; margin-bottom:4px; color: #00aa00;">#2</div>
              <div><strong>수평점</strong>: <span>${params[1]?.data?.x ?? '-'}m</span></div>
              <div><strong>수직점</strong>: <span>${params[1]?.data?.y !== undefined ? parseInt(params[1].data.y) : '-'}m</span></div>
              <br>
              <div style="font-weight:bold; margin-bottom:4px; color: #0000ff;">#3</div>
              <div><strong>수평점</strong>: <span>${params[2]?.data?.x ?? '-'}m</span></div>
              <div><strong>수직점</strong>: <span>${params[2]?.data?.y !== undefined ? parseInt(params[2].data.y) : '-'}m</span></div>
            </div>
          `;
        }
      },
      xAxis: {
        type: 'value',
        max: 300,
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: {
          show: true,
          lineStyle: { type: 'solid', color: '#ccc', width: 1 }
        },
        boundaryGap: false
      },
      yAxis: {
        type: 'value',
        min: -20,
        interval: 5,
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: true }
      },
      series: [
        {
          name: '#1',
          type: 'line',
          datasetIndex: 0,
          encode: { x: 'x', y: 'y' },
          smooth: true,
          symbol: 'circle',
          showSymbol: false,
          emphasis: {
            focus: 'series'
          },
          itemStyle: {
            color: '#ff0000'
          },
        },
        {
          name: '#2',
          type: 'line',
          datasetIndex: 1,
          encode: { x: 'x', y: 'y' },
          smooth: true,
          symbol: 'circle',
          showSymbol: false,
          emphasis: {
            focus: 'series'
          },
          itemStyle: { 
            color: '#00aa00'
           },
        },
        {
          name: '#3',
          type: 'line',
          datasetIndex: 2,
          encode: { x: 'x', y: 'y' },
          smooth: true,
          symbol: 'circle',
          showSymbol: false,
          emphasis: {
            focus: 'series'
          },
          itemStyle: { 
            color: '#0000ff'
          },
        }
      ]
      };

    // 풋뷰 차트 옵션
    const footViewChartOption = {
      dataset: {
        source: footViewChartData
      },
      grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          containLabel: false,
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#fff',
        borderColor: '#ddd',
        borderWidth: 1,
        formatter: function (params) {
          const item = params[0];
          return `
            <div style="padding:6px 10px;">
              <div style="font-weight:bold; margin-bottom:4px; color: #00aa00;">Step Data</div>
              <div><strong>L</strong>: <span>${item.data.x}</span></div>
              <div><strong>R</strong>: <span>${parseInt(item.data.y)}</span></div>
            </div>
          `;
        }
      },
      xAxis: {
        type: 'value',
        axisLabel: { show: false },
        axisLine: { show: false },
        splitLine: { show: false },
        axisTick: { show: false },
        boundaryGap: false,
      },
      yAxis: {
        axisLabel: { show: false },
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: false },
      },
      series: [{
        type: 'line',
        smooth: true,
        symbol: 'circle',
        showSymbol: false,
        symbolSize: 6,
        itemStyle: { color: '#00aa00' },
      }],
    };

    // 차트 옵션
    sideViewChart.setOption(sideViewChartOption);
    topViewChart.setOption(topViewChartOption);
    footViewChart.setOption(footViewChartOption);

    // 창 크기 조정(반응형)
    window.addEventListener('resize', () => {
      sideViewChart.resize();
      topViewChart.resize();
      footViewChart.resize();
    });
  }
};
</script>

<style scoped>

</style>